import React from "react";
import colors from "tokens/colors";

export default ({ color = colors.primary }) => (
  <svg viewBox="0 0 882.2 553.5">
    <defs>
      <style>
        {`.prefix__cls-1,.prefix__cls-21{fill:${color}}.prefix__cls-1,.prefix__cls-10,.prefix__cls-14,.prefix__cls-9{opacity:.1}.prefix__cls-10{fill:#fff}.prefix__cls-5{fill:#95b6f0}.prefix__cls-6{opacity:.05}.prefix__cls-7{fill:#5f546f}.prefix__cls-8{fill:#ccccd8}.prefix__cls-11{fill:#c27099;opacity:1}.prefix__cls-12{fill:#4c4981}.prefix__cls-16{fill:#aea4b2}.prefix__cls-17{fill:#ffc4d0}.prefix__cls-18{fill:#575989}.prefix__cls-22{fill:#d4dfec}.prefix__cls-23{fill:#444053}.prefix__cls-24{fill:#efeeff}`}
      </style>
      <linearGradient
        id="prefix__linear-gradient"
        x1={0.5}
        x2={0.5}
        y1={1}
        gradientUnits="objectBoundingBox"
      >
        <stop offset={0} stopColor="gray" stopOpacity={0.3} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.1} />
        <stop offset={1} stopColor="gray" stopOpacity={0.1} />
      </linearGradient>
      <linearGradient
        id="prefix__linear-gradient-2"
        x1={0.5}
        x2={0.5}
        y1={1}
        xlinkHref="#prefix__linear-gradient"
      />
    </defs>
    <g
      id="prefix__Group_24"
      data-name="Group 24"
      transform="translate(-980.8 -2428)"
    >
      <g
        id="prefix__undraw_conversation_h12g_1_"
        data-name="undraw_conversation_h12g (1)"
        transform="translate(980.8 2498)"
      >
        <path
          id="prefix__Path_133"
          d="M807.5 213.2l-.2 3a86.5 86.5 0 0 1-6.4 25.6c-11.4 27.1-34.3 47.8-58.6 64.4l-1.6 1c-4.4 3-8.9 5.8-13.4 8.6l-.4.3-.2.1-.9.5-1.9 1.2-1 .7-5 3-4.4 2.6-8.3 5a554.4 554.4 0 0 0-27.2 17.3l-1.3.9-2 1.4q-5 3.5-9.8 7.2l-1.9 1.5a87.5 87.5 0 0 0-17 17.5 41.6 41.6 0 0 0-7.6 18.7 55 55 0 0 0 7.6 31.5c3.3 6.6 7.3 13.1 11 19.6l3.3 6.3a88.5 88.5 0 0 1 5 11.5c3 8.4 3.8 16.9.5 25.5a40.5 40.5 0 0 1-19.9 20.3c-4.7 2.6-9.8 5-15 7.2-7.4 3.2-15 6.5-21.5 10.8l-1.3.8-2.5 1.8-3.9 3.3-2.2 2a64.5 64.5 0 0 0-4.8 5.2l-.8 1-2.3 2.6-2.8 3.6-4 5-1.2 1.5c-2.2 2.7-4.5 5.5-6.8 8l-.3.3a49 49 0 0 1-19.5 13.7c-18.8 6.5-37.4-3.2-55.4-13.6l-.5-.3-.2-.1-1.5-1-.8-.3-5.5-3.2-.4-.3-7.7-4.2q-2.3-1.3-4.7-2.4a131.2 131.2 0 0 0-16-6.4 138 138 0 0 0-21.9-5.3q-4.5-.7-9.1-1.1l-6-.4a140 140 0 0 0-47.5 5.8 164 164 0 0 0-6.3 2l-1.1.4-5.7 2.3-.7.3c-9.7 4.2-19 9.5-28.7 13.6l-2.6 1.1a75.7 75.7 0 0 1-18.7 5.2 70 70 0 0 1-20-.5 140.5 140.5 0 0 1-17.6-4.1l-.4-.1-1.6-.5-.7-.2-1-.3c-13.5-4.2-27.2-9.1-41.2-10.4l-2-.2a86.9 86.9 0 0 0-13 0c-13 1-26 4.6-38.8 8.3l-.8.2-2.1.6-1.5.5-3 .8-.7.2c-21.2 6.1-42.2 11.3-63 5.3A75.2 75.2 0 0 1 84 554a135.3 135.3 0 0 1-15-13.7c-4.5-4.6-8.6-9.3-12.7-14.1-13.5-15.9-26.8-32.7-32.7-52.7A102.8 102.8 0 0 1 20 452c-.3-4.5-.4-9-.4-13.4v-9l.3-6.4v-4.1l1.8-56.2c.4-12.5.8-25.2 4.7-37a81.8 81.8 0 0 1 2.7-7.2c8.6-19.3 25.1-35.1 39.8-51.3a192.6 192.6 0 0 0 15-18.4 67.8 67.8 0 0 0 13.4-35.7v-3c-.3-17.5-9.6-34.2-13.4-50.9a49.4 49.4 0 0 1 0-24.7c6.6-22.6 32.4-34.4 56-38.2 24.4-4 49.3-2.8 73.7.7l4.8.7c5 .8 10 1.8 15 2.8 12.2 2.6 24.2 5.6 36.3 8 15.6 3.2 29.7.2 45.2-2q12-1.7 24-2.3 10-.6 20-.4a281.5 281.5 0 0 1 79.4 12.6c17.2 5.3 34.2 12.5 51.8 16.3a115.3 115.3 0 0 0 18.2 2.7h1.5c41.6 1.9 79.8-23 121-27.6l1.4-.1a128.1 128.1 0 0 1 13.7-.7c38.5.2 75.8 16.7 111.1 33 10.8 5 21.7 10.1 30.5 18.1a68.4 68.4 0 0 1 20 55z"
          className="prefix__cls-1"
          data-name="Path 133"
          transform="translate(-19.4 -93.8)"
        />
        <path
          id="prefix__Path_134"
          d="M442.4 420.8v-97.4h26.9l-.7-.6-.2-.1-.4-.4-.5-.4-.4-.4-.5-.3-.7-.6a1.8 1.8 0 0 0-.2-.1h-23.3V315l-.6.4-.7.4a.8.8 0 0 1-.2.1l-.4.3-.4.3-1.2 1-.4.4-.8.7-3.2 3-.8.6a20.7 20.7 0 0 1-1.8 1.4 8.7 8.7 0 0 1-.7.5l-.5.2-.4.2a15.1 15.1 0 0 1-3 1v95.2h-40.2a1.5 1.5 0 0 0 0 .3l.7 2.7h39.6v104.4h1.3l1.3.2 2 .2a6.2 6.2 0 0 1 1 .1l1 .2h.2l1.8.3a2 2 0 0 1 .4 0l.9.2 1.2.3 3-.1h.4l.5.2v-106h62.3v-.4l.2-2.5zm93 0h-2.6v3h3zm-30.5 0l-.2 2.6v.4h23.4v-.1l1.7-2.9zM83.4 138.6c-1.7 7.5-1.1 15 .6 22.5v-24.7l-.6 2.2zm385.2 184.2l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.1 1v.3h6.3zm-50 99.6l-.7-.4 2.2-1.2H275.4a6.1 6.1 0 0 0 .3.7l.2.4.2.5.5.8.4.7h144l-2.3-1.5zm-185-73.4v.2-.3zm-.1-14.6a3 3 0 0 1-.7.7l.7.9a1.8 1.8 0 0 1-.1.2l-.1.3v.1a2 2 0 0 1-.2.3.5.5 0 0 1-.1 0 2.7 2.7 0 0 1-.3.4l-.1.1a2.2 2.2 0 0 1-.3.3h-.1v.2a15.5 15.5 0 0 1 1.5 2V334l-.2.2zm184.1 86.5h-21c5.6 2 14.5 1.4 20.5.5l1.1-.1-.6-.4zm45.3 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3.3.3 0 0 0 .1.2 3.6 3.6 0 0 1 .1.4l.1.4v.3a1 1 0 0 1 0 .1 2.8 2.8 0 0 1 0 .3 3.8 3.8 0 0 1 .1.7 6.1 6.1 0 0 1-4.1 5.4 6 6 0 0 1-2.2.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.8h22.5v20.4h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8h193.8v4.5l1.6 1.3.9.6 2.9 2.6.7.8 1 1 .8.9.5.6.8 1 .7 1 .7 1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.6a4.7 4.7 0 0 1 .1.5 3.7 3.7 0 0 0 .1.5v.4a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-229.2-3v-97.4h193.8v97.4zm186.4 0h-25.6l1.6.8c5.3 2.7 15.1 2 21.5 1l1.1-.2-.7-.4 2.1-1.2zm-311.2 0l2 3H196l.2-.8.2-.7.3-1.5zm308.7 0h-21c5.6 2 14.5 1.4 20.5.5l1.1-.1-.6-.4zm-308.7 0l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3.4.4 0 0 0 .1.2 3.6 3.6 0 0 1 .1.4l.1.4v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .2 3.8 3.8 0 0 1 .1.7 6.1 6.1 0 0 1-4.1 5.4 6 6 0 0 1-2.2.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.8h22.5v20.4h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-45.3-3h-21c5.6 2 14.5 1.4 20.5.5l1.1-.1-.6-.4zm51-98v-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.7 98l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.8-101l-.2-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.8 98l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4l-.5-1-.1-.2-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.8-101l-.2-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.8 98l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.1-.2 1 1 0 0 0-.2-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.5-1l-.1-.2-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.8-101l-.1-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.8 98l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.1-.2 1 1 0 0 0-.2-.1 4 4 0 0 1-.5-.7 4.8 4.8 0 0 1-.3-.4 23 23 0 0 1-.5-1v-.2l-.3-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.8-101l-.1-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.8 98l2 3H196l.2-.8.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.1-.2 1 1 0 0 0-.2-.1 4 4 0 0 1-.5-.7 4.8 4.8 0 0 1-.3-.4 23 23 0 0 1-.5-1v-.2l-.3-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.8-101l-.1-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.7 98l2 3h85c.2-.2.2-.5.3-.8l.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.2-.1 4 4 0 0 1-.5-.7 4.8 4.8 0 0 1-.3-.4 23 23 0 0 1-.5-1v-.2l-.3-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.7-101l-.1-2.4H462a3.7 3.7 0 0 0 .1.4l.2 1.4.1 1v.3h6.3zm-359.7 98l2 3h85c.2-.2.2-.5.3-.8l.2-.7.3-1.5zm354 3a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.2-.1 4 4 0 0 1-.5-.7 4.8 4.8 0 0 1-.3-.4 23 23 0 0 1-.5-1v-.2l-.2-.4h-18.6v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8a76.6 76.6 0 0 1-3.5 1.6l-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a2 2 0 0 1 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7a59.8 59.8 0 0 1 3.6 3.4l1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4 3.9 3.9 0 0 1 0 .5 2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm5.7-101l-.1-2.4H462a3.7 3.7 0 0 0 0 .4l.3 1.4.1 1v.3h6.3zM646 215V109a128.2 128.2 0 0 0-13.7.6l-1.4.2V215H447l-.5-.5.7-.9 3-3.7 3-3.8 55.3-68.8a115.3 115.3 0 0 1-18.2-2.7l-47.8 59.5v-71.6q-7.5-1.5-15-3.3v71.6L359 105.7q-10-.2-20 .4l84.4 105 2.2 2.8.5.5-.5.6h-192V102.4c-5-1-10-2-15-2.8V215H97.3l-.2 3h121.3v102.4H84v-69.7a192.6 192.6 0 0 1-15 18.4v51.3H29.2c-.5 1-1 2-1.3 3h41v97.4H20v3h49v118.3a135.3 135.3 0 0 0 15 13.7v-132h134.5V553a86.9 86.9 0 0 1 13-.1l2 .2V423.8h193.9v114.7l6 .5 9 1V423.9H631v93.7a187 187 0 0 0 15-7.2v-83.1a55 55 0 0 1-7.5-31.6 41.6 41.6 0 0 1 7.6-18.7v-53.5h72l5-3h-77V218h161.4l.2-3zm-15 3v102.4H442.3v-99.6l.2-.2 2.5-2.6zm-397.5 0h193.9v102.4H233.6zM84 420.8v-97.4h134.5v97.4zm149.6 0v-97.4h193.8v97.4zm208.8 0v-97.4H631v97.4zm26.2-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2 1v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2.9v.4h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3 1.2 1.2 0 0 0 .1.2 3.6 3.6 0 0 1 .1.5l.1.3v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .3 3.8 3.8 0 0 1 .1.6 6.1 6.1 0 0 1-4.2 5.4 6 6 0 0 1-2.1.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.9h22.5v20.3h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4H420l-2 1.2.7.4 2.2 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.3 9.3 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm359.8-98l-.2-2.4H462a3.7 3.7 0 0 0 0 .4l.2 1.4.2.9v.3h6.2zm-5.8 101a1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.1 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.6-1v-.2l-.2-.4h-18.5v-97.4h20v-.3l-.2-1-.2-1.3a2.8 2.8 0 0 0 0-.4h-19.6v-74.9a1 1 0 0 0-.3 0 2 2 0 0 0-.3.1l-.2.1-.4.1-.2.1-1.7.8-3 1.4-.5.2-.8.3-1.4.5-1 .4a31 31 0 0 1-2.7.7l-.8.1-1 .2h-.7v70H233.6v-85.7l-.4.3c-2.5 1.3-5.6 1-7.7 2.9-2.8 2.3-2.3 6.5-1.4 9.9l.3.9a1.8 1.8 0 0 0 0 .3.3.3 0 0 0 .1.2 3.6 3.6 0 0 1 .1.4l.1.4v.3a.5.5 0 0 0 0 .2 1.4 1.4 0 0 1 0 .2 3.8 3.8 0 0 1 .1.7 6.1 6.1 0 0 1-4.1 5.4 6 6 0 0 1-2.2.2v63.3h-12.4l.3 3h12.1v97.4h-21.8a21.8 21.8 0 0 1-.5 2.2l-.2.8h22.5v20.4h4.5l2.3-.2h1.5l.8-.2h.5l.5.1h.1l1.2.2.7.1h.3l1 .2h.2l1.6.2v-20.8H279a32.6 32.6 0 0 1-2-3h-43.5v-97.4h193.8v97.4h-33l1.6.8c5.3 2.7 15.1 2 21.5 1l1.1-.2 2.3 1.4h6.5v4.4l1.6 1.3.9.7 2.9 2.6.7.8 1 1 .8.9.5.5.8 1 .7 1 .7 1.1a12.7 12.7 0 0 1 .7 1.3h1.4l.2.3.1.3.5 1.3.2.5a4.7 4.7 0 0 1 .1.6 3.7 3.7 0 0 0 .1.4v.5a2.5 2.5 0 0 1 .1.4v.4a8 8 0 0 1 0 1.1 9.4 9.4 0 0 0 1-.2v-22.2h20.4zm-354-3l2 3H196l.2-.8.2-.7.3-1.5zm311.3 0h-25.7l1.6.7c5.3 2.8 15.1 2 21.5 1.1l1.1-.2-.7-.4 2.1-1.2zm22.4 0v-97.4h26.8l-.7-.6-.2-.1-.4-.4-.5-.4-.4-.4-.5-.3-.7-.6a1.8 1.8 0 0 0-.2-.1h-23.3V315l-.6.4-.7.4a.8.8 0 0 1-.2.1l-.4.3-.4.3-1.2 1-.4.4-.8.7-3.2 3-.8.6a20.7 20.7 0 0 1-1.8 1.4 8.7 8.7 0 0 1-.7.5l-.5.2-.4.2a15.1 15.1 0 0 1-3 1v95.2h-40.2a1.5 1.5 0 0 0 0 .3l.7 2.7h39.6v104.4a2.4 2.4 0 0 1 .3 0h1l1.3.2 2 .2a6.2 6.2 0 0 1 1 .1l1 .2h.2l1.8.3a2 2 0 0 1 .4 0l.8.2 1.3.3 3-.1h.4l.5.2v-106H503l.3-3zm60.8 0l-.3 3h26l1.8-3zm32.2 0h-2.7v3h3zm-93 0v-97.4h26.8l-.7-.6-.2-.1-.4-.4-.5-.4-.4-.4-.5-.3-.7-.6a1.8 1.8 0 0 0-.2-.1h-23.3V315l-.6.4-.7.4a.8.8 0 0 1-.2.1l-.4.3-.4.3-1.2 1-.4.4-.8.7-3.2 3-.8.6a20.7 20.7 0 0 1-1.8 1.4 8.7 8.7 0 0 1-.7.5l-.5.2-.4.2a15.1 15.1 0 0 1-3 1v95.2h-40.2a1.5 1.5 0 0 0 0 .3l.7 2.7h39.6v104.4h1.3l1.3.2 2 .2a6.2 6.2 0 0 1 1 .1l1 .2h.2l1.8.3a2 2 0 0 1 .4 0l.9.2 1.2.3 3-.1h.4l.5.2v-106h62.3v-.4l.2-2.5zm62.5 0l-.3 2.6v.4h23.4v-.1l1.7-2.9zm30.5 0h-2.7v3h3z"
          className="prefix__cls-1"
          data-name="Path 134"
          transform="translate(-19.6 -95.7)"
        />
        <path
          id="prefix__Path_135"
          fill="#fff"
          d="M665.3 621.5l-19.5-.4-15-.2-30.9-.5h-1.3l-26-.5-51.8-.9-28.1-.4h-4.9l-2.6-.1h-1.4l-14.6-.3-8.4-.2h-3.2l-15.3-.3-15-.2-121.3-2h-1.6l-46-.8h-2.9l-22-.4-15-.3-13.7-.2h-1.1l-53.6-.9-17.8-.4-48.5-.8H79l-10-.2-49-.8c-.3-4.5-.4-9-.4-13.5v-8.9l49.3 1 9.5.3h.2l5.4.1 22.6.5 12.1.3 72 1.5 5 .1 22.8.5h2.8l5 .2 6.7.2h.5l21.6.4 30.9.7h1.9l73.8 1.6h1.2l64.4 1.4 10 .3h5.1l2.8.1 12.8.3h7l1.6.1 8.8.2 31.5.7h3.5l87 2h1.2l32.3.6 13.4.3 1.6.2 11 1.5 3.4 6.4a88.5 88.5 0 0 1 5.1 11.7z"
          data-name="Path 135"
          transform="translate(-19.4 -252.6)"
        />
        <path
          id="prefix__Path_136"
          fill="#d0d0db"
          d="M665.3 625.7l-19.5-.3-15-.3-30.9-.5h-1.3l-26-.4-51.8-1-28.1-.4h-4.9l-2.6-.1h-1.4l-14.6-.3-8.4-.1h-3.2l-15.3-.3-15-.3-121.3-2h-1.6l-46-.8h-2.9l-22-.4-15-.2-13.7-.3h-1.1l-53.6-.9-17.8-.3-48.5-.9H79l-10-.2-49-.8c-.3-4.5-.5-9-.4-13.4l49.3 1 10.2.1h.2l4.7.1 28.5.6 16.2.3 27.2.6 27 .5 15.6.3h.3l17 .3h2.6l15.1.4h.3l7.8.1 2.7.1h4.8l44.3 1h1.8l132.1 2.6 15 .3 13 .2h1.6l10.5.2 2 .1h1.5l31.8.6h3.6l37.8.8 41.3.8 11.6.3h1.1l32.7.6 15 .3 14.5.3a88.5 88.5 0 0 1 5 11.7z"
          data-name="Path 136"
          transform="translate(-19.4 -256.8)"
        />
        <path
          id="prefix__Path_137"
          fill="url(#prefix__linear-gradient)"
          d="M765.5 578.6l-1.2.8q-1.3.8-2.5 1.8a60 60 0 0 0-4 3.3l-2.1 2a64.5 64.5 0 0 0-4.9 5.2l-.8 1-2.2 2.6-2.9 3.6-4 5-1.1 1.5-6.8 8h-76l-1.6-1-.7-.4-5.5-3.2-.5-.2c-2.6-1.5-5.1-3-7.7-4.3l-4.6-2.3a131.2 131.2 0 0 0-16-6.4 138 138 0 0 0-22-5.3q-4.5-.7-9-1.1l-6-.5a140 140 0 0 0-47.6 5.8 164 164 0 0 0-6.2 2.1l-1.2.4.3-1c.5-2.6 2.9-5.5 6.1-8.3 1.4-16.6 15.3-29.9 15.3-29.9l32.9-14.2.4-.3a79.8 79.8 0 0 1 15-8.1 9 9 0 0 1 1.5-.4c6-1.2 11.3-6 15.6-8.7 1.9-1.1 2.2-5.3 2-9.6a6 6 0 0 0 0-1h-1l-.3-.4-.2-.7-.1-.3h-1l-1-3a56.1 56.1 0 0 1-2.2-8 2.3 2.3 0 0 1 0-.3 24.2 24.2 0 0 1-.4-3.7 14 14 0 0 1 .1-2.8 9 9 0 0 1 .3-1.2h-.6l-1.6.2h-.5l-.3.2-10.3 1h-2.9a8.5 8.5 0 0 0 .2-1h-1l-.5.1a78.6 78.6 0 0 1-10.8-.1 310.1 310.1 0 0 1-31.2-4.2S533 495.6 519 489a24.5 24.5 0 0 1-7-5 22.5 22.5 0 0 1-4.7-6.9 17.3 17.3 0 0 1-1-3.1 9.3 9.3 0 0 1-.3-3c1.2-13.6 37.8-4.4 45.3-.6a11.8 11.8 0 0 0 1.3.6c5.6 2 14.5 1.3 20.4.5l1.2-.2-.6-.3-.2-.1a35.4 35.4 0 0 1 10-4.3 24.2 24.2 0 0 1 6.6-.7 37.6 37.6 0 0 1 6.7.6h.1a7.9 7.9 0 0 0 1.7-.4 3.9 3.9 0 0 0 2.6-4.8 12 12 0 0 1 .7-6.7s3.4.9 3-3.4a14 14 0 0 0-.6-2.6l-.3-1.4v-.1a31.8 31.8 0 0 1 1-14.3l1.8-2.2v-.3l.1-.1-.9-4.7-.2-1.1-.5-16s-.2-25.3 8-28.9l-.1-1.1-.2-2a19.8 19.8 0 0 1-5.6-2.7 5 5 0 0 1-1.2-1.3 2.2 2.2 0 0 1-.3-1.7 3.4 3.4 0 0 1 1.1-1.7 18 18 0 0 0 5.3-9.6l2.3-3.8.3-.5c-1.5-5.4-3.2-11-4.9-15.7l-.4-1.4-.3-.8-.4-1.3h-.6a35 35 0 0 1-6.2.7 34.3 34.3 0 0 1-33.6-41.9 32.2 32.2 0 0 1 .7-2.4 5.9 5.9 0 0 0-3.6.4c-1.7.8-3.2 2-4.8 2.9a11.4 11.4 0 0 1-5.2 1.2 11.6 11.6 0 0 1-3.3-.5 11.6 11.6 0 0 1-3.9-2 3.3 3.3 0 0 0 .8 0h.9l.7-.3h.1l.6-.2.2-.1.7-.3a7.2 7.2 0 0 0 .6-.4 1.3 1.3 0 0 1 .2 0l.5-.4h.1l.7-.5a15.9 15.9 0 0 0 2.2-2.2 41.2 41.2 0 0 0 5.4-8.7l4-8c.9-1.7 1.7-3.3 2.7-4.8a20.3 20.3 0 0 1 2.3-3 12 12 0 0 1 2.5-2.1 13 13 0 0 1 6-1.8c3.3-.3 6.8.3 10.2.2a41.6 41.6 0 0 0 13.3-3.2 39.8 39.8 0 0 1 6.2-2 13.7 13.7 0 0 1 2.6-.3 16.3 16.3 0 0 1 7 1.7 27.7 27.7 0 0 1 8.6 6.3l1 1.2 2.4 3 2 2.5c3.4 3.7 7.4 6.6 10.6 10.5s5.7 9 4.8 14.2c0 .4-.2.8-.3 1.1a1.2 1.2 0 0 1 0 .4l-.3.7-.1.4-.3.8a18.4 18.4 0 0 0-1.4 5.7 7.5 7.5 0 0 0 0 .9c.2 2.5 1.4 5 2.1 7.4a13.4 13.4 0 0 1 .7 3.5v1.3a6.6 6.6 0 0 1-.2 1 .6.6 0 0 1 0 .2 4.8 4.8 0 0 1-.2.5.2.2 0 0 1 0 .2l-.2.4v.1a3 3 0 0 1-.3.4 1 1 0 0 1 0 .1 4.6 4.6 0 0 1-.4.5l-.3.2 1 .6.3.2c3.3.7 12.9 2.7 16.7 2.9a16.4 16.4 0 0 1 5.2 1.9 46.7 46.7 0 0 1 21.2 22c3.1 6.8 6.9 14.2 8.9 15.7a21.1 21.1 0 0 1 4.6 6 51.1 51.1 0 0 1 3.3 6.7s15.6 10.5 13.7 20.9c0 0 3.4 11.5 6.7 14.8s11.1 30.3 11.1 30.3 2.9 5 2.7 8.9 2.8 12 2.8 12l1.6 6.8.9 3c.6 2 1.3 3.5 1.9 4 1.9 1.7 1 5.3 1 5.3s2.3 6.3 3.5 8a5.9 5.9 0 0 1 .7 2.7 31 31 0 0 1-.2 4.7l-.2 3.2c-.2 3-.2 7.2 1 8.8a6.6 6.6 0 0 1 .8 2.9c.6 4 .1 10.3 1.8 11.8 2.2 1.9 1.2 19.4 1.2 19.4s3.4 21.7 6.3 33.7z"
          data-name="Path 137"
          transform="translate(-175.7 -146)"
        />
        <path
          id="prefix__Path_138"
          d="M693.4 663.6l-2.3 2-11 9-2.3 1.8-9.7 8s-27.2 15.8-55.5 29.3l-9.1 4.2-6-.4a140 140 0 0 0-47.5 5.7 30.2 30.2 0 0 1-.2-6.3 53.2 53.2 0 0 1 15.2-29.7l32.5-14.1 15-6.5 22.8-9.8 7.1.8 13 1.6z"
          className="prefix__cls-5"
          data-name="Path 138"
          transform="translate(-189.8 -274.6)"
        />
        <path
          id="prefix__Path_139"
          d="M693.4 663.6l-2.3 2-11 9-2.3 1.8-9.7 8s-27.2 15.8-55.5 29.3l-9.1 4.2-6-.4a140 140 0 0 0-47.5 5.7 30.2 30.2 0 0 1-.2-6.3 53.2 53.2 0 0 1 15.2-29.7l32.5-14.1 15-6.5 22.8-9.8 7.1.8 13 1.6z"
          className="prefix__cls-6"
          data-name="Path 139"
          transform="translate(-189.8 -274.6)"
        />
        <path
          id="prefix__Path_140"
          d="M704.4 760.6v.6l-.5 3.3v.7l-.2 1.2-.3 1.8-.4-.2-7.7-4.3-4.7-2.3a131.2 131.2 0 0 0-16-6.4l1.5-2.7 9 2.6 13 3.8 2.4.7 2 .6z"
          className="prefix__cls-7"
          data-name="Path 140"
          transform="translate(-229.9 -305.3)"
        />
        <path
          id="prefix__Path_141"
          d="M704.4 760.6v.6l-.5 3.3v.7l-.2 1.2-.3 1.8-.4-.2-7.7-4.3-4.7-2.3a131.2 131.2 0 0 0-16-6.4l1.5-2.7 9 2.6 13 3.8 2.4.7 2 .6z"
          className="prefix__cls-6"
          data-name="Path 141"
          transform="translate(-229.9 -305.3)"
        />
        <path
          id="prefix__Path_142"
          d="M669 655.6l17.5 7.1 2.7 7.9-18.1-7.1z"
          className="prefix__cls-8"
          data-name="Path 142"
          transform="translate(-214.8 -210.6)"
        />
        <path
          id="prefix__Path_143"
          d="M669 655.6l17.5 7.1 2.7 7.9-18.1-7.1z"
          className="prefix__cls-6"
          data-name="Path 143"
          transform="translate(-214.8 -210.6)"
        />
        <path
          id="prefix__Path_144"
          d="M812.5 761l-4 5.2-1.2 1.4c-2.2 2.7-4.4 5.5-6.8 8l-.2.3-75 .1-.4-.3-.2-.1-1.6-1-.7-.3-5.5-3.2-.5-.3.1-1.6v-1.4l.2-2.6v-1l1.1-.1z"
          className="prefix__cls-7"
          data-name="Path 144"
          transform="translate(-243.3 -308.1)"
        />
        <path
          id="prefix__Path_145"
          d="M744.3 777.3h-7.7l-8.9-.2-1.5-.9-.2-5.5V767l16.8-1h.8l.2 3.1v1.4l.5 6.9z"
          className="prefix__cls-9"
          data-name="Path 145"
          transform="translate(-246.4 -309.7)"
        />
        <path
          id="prefix__Path_146"
          d="M743.2 777.3H736l-8.5-.2-1.6-.9-.7-.4-.1-5v-4l17.6-1v.2l.2 3v1.4l.5 6.9z"
          className="prefix__cls-7"
          data-name="Path 146"
          transform="translate(-246 -309.7)"
        />
        <path
          id="prefix__Path_147"
          d="M743.2 777.3H736l-8.5-.2-1.6-.9-.7-.4-.1-5v-4l17.6-1v.2l.2 3v1.4l.5 6.9z"
          className="prefix__cls-10"
          data-name="Path 147"
          transform="translate(-246 -309.7)"
        />
        <path
          id="prefix__Path_148"
          d="M717.9 764l94.7-3-4 5.2-1.2 1.4-66.5 1.2h-.7l-17.1.4h-5.5a2.3 2.3 0 0 1-.3 0 2.6 2.6 0 0 1-.6 0v-1.5l.1-2.5v-1z"
          className="prefix__cls-9"
          data-name="Path 148"
          transform="translate(-243.4 -308.1)"
        />
        <path
          id="prefix__Path_149"
          d="M817.1 750.5l-.8 1-2.2 2.7-2.9 3.5-4 5-67.8 1.3h-.7l-17 .4H716a3.5 3.5 0 0 1-.6 0h-.2a3.6 3.6 0 0 1-2.8-4l.2-1.5.2-1.5.1-.8.3-1.6v-.5z"
          className="prefix__cls-8"
          data-name="Path 149"
          transform="translate(-242 -304.7)"
        />
        <path
          id="prefix__Path_150"
          d="M819.4 737l3.2 1-2.2 2.1a64.5 64.5 0 0 0-4.8 5.2l-.8 1-2.2 2.6-99.1 2.7h-1.3l-.5-1.9-4-15.5 95.8 2.3 5.5.1z"
          className="prefix__cls-7"
          data-name="Path 150"
          transform="translate(-240.5 -299.5)"
        />
        <path
          id="prefix__Path_151"
          d="M773 713l-4 3.3-2.1 2.1a64.5 64.5 0 0 0-4.9 5.2l-.8 1a444.8 444.8 0 0 1-71.8 2.7 97.9 97.9 0 0 0-29.5 2.6l-1.2.3-1 .3a83 83 0 0 0-8.2 2.7l-1.8.7a131.3 131.3 0 0 0-16-6.4 138 138 0 0 0-22-5.3q-4.5-.7-9-1.1l-6-.5a140 140 0 0 0-47.6 5.8 164 164 0 0 0-6.2 2.1v-.2c.6-2.6 2.9-5.4 6.1-8.2 10.5-9.2 30.4-18.2 30.4-18.2l10.6-4.5 6.7-2.9 15-6.4 31.9-13.5.3-.1 7.4-3.1 6.7-2.9a53.6 53.6 0 0 1 14.3-1.8h1.9a12 12 0 0 1 1.4 0h.9a74.5 74.5 0 0 1 4.7.5h1.1l1.1.2 1.2.2 2.2.4 3.5.6 1.7.4 5.2 1.3 1.7.4 1 .3 1.4.4c3.2 1 6.4 2 9.6 3.2l1.7.6 1.6.6 3 1.2c5.5 2.3 10.9 4.7 16 7.3l1.7.8.9.5 1.8 1 1.7.9 1 .4.8.5.8.5 5.9 3.3 1.5 1 .8.4a195.9 195.9 0 0 1 6.6 4.1l1.4 1 .7.4 1.2.8.8.5 1.4 1 .7.5.2.2 1.6 1.2 1 .8 1 .7 2 1.5.7.7.4.3.4.3.7.7.5.4.5.5a22 22 0 0 1 1.7 1.8l1 1.5z"
          className="prefix__cls-5"
          data-name="Path 151"
          transform="translate(-187 -277.8)"
        />
        <path
          id="prefix__Path_152"
          d="M601 594.6a17 17 0 0 1-5.8 1.2c-13.8 1-41.6-4.3-41.6-4.3s-35 7.9-44.5-14 35.2-11 43.6-6.7c5.3 2.7 15.1 2 21.5 1l6.1-1s29.6 19.5 20.7 23.8z"
          className="prefix__cls-11"
          data-name="Path 152"
          transform="translate(-176.3 -244.9)"
        />
        <path
          id="prefix__Path_153"
          d="M671 535.8l-7.8 38.4-23.4 2-11.7 1c2.9-11.8-21.9-25.4-21.9-25.4 12.6-7.7 20-4.1 22.7-4.3a1.5 1.5 0 0 0 .5 0c2.4-.4 4.9-2 4.2-5.3a12 12 0 0 1 .7-6.6s4.5 1.2 2.4-6 .7-15.7.7-15.7l1.7-2.2 2.6-8 10.7 10.9z"
          className="prefix__cls-12"
          data-name="Path 153"
          transform="translate(-208 -225.4)"
        />
        <path
          id="prefix__Path_154"
          d="M671 536.2l-7.8 38.4-23.4 2-11.7 1c2.9-11.9-21.9-25.5-21.9-25.5 12.6-7.6 20-4 22.7-4.2l.5-.1c2.4-.4 4.9-1.8 4.2-5.2a12 12 0 0 1 .7-6.7s4.5 1.2 2.4-6 .7-15.6.7-15.6l1.7-2.2 2.6-8 10.7 10.9z"
          className="prefix__cls-6"
          data-name="Path 154"
          transform="translate(-208 -225.5)"
        />
        <path
          id="prefix__Path_155"
          d="M645.3 594.4l-3.4 2.3-11.7 1c3-11.9-21.9-25.4-21.9-25.4 12.7-7.7 20-4.1 22.7-4.3a1.5 1.5 0 0 0 .5-.1c3.1 4 7.1 8.7 9.5 9.8 4.3 2.2 13.5 10 4.3 16.7z"
          className="prefix__cls-9"
          data-name="Path 155"
          transform="translate(-208.6 -245.9)"
        />
        <path
          id="prefix__Path_156"
          d="M632.5 597.7a17 17 0 0 1-5.8 1.2c1.2-10.2-16.6-21.3-21-24l6-1s29.6 19.5 20.8 23.8z"
          className="prefix__cls-9"
          data-name="Path 156"
          transform="translate(-207.7 -248)"
        />
        <path
          id="prefix__Path_157"
          d="M643.2 594.4a118 118 0 0 1-3.4 2.3l-11.7 1c2.9-11.9-21.9-25.4-21.9-25.4 12.6-7.7 20-4.1 22.7-4.3a1.5 1.5 0 0 0 .5-.1c3.1 4 7.1 8.7 9.5 9.8 4.3 2.2 13.5 10 4.3 16.7z"
          className="prefix__cls-12"
          data-name="Path 157"
          transform="translate(-208 -245.9)"
        />
        <path
          id="prefix__Path_158"
          d="M643.2 595.1l-3.4 2.3-11.7 1c2.9-11.9-21.9-25.4-21.9-25.4 12.6-7.7 20-4.1 22.7-4.3a3.3 3.3 0 0 0 .5 0c3.1 4 7.1 8.6 9.5 9.7 4.3 2.2 13.5 10 4.3 16.7z"
          className="prefix__cls-6"
          data-name="Path 158"
          transform="translate(-208 -246.1)"
        />
        <path
          id="prefix__Path_159"
          d="M706.4 356.4s-44.8 62.7-41.2 51.2c2.4-7.5-4.2-29-8.9-42.9-2.5-7.2-4.5-12.3-4.5-12.3s25.8-22.2 25.3-17.2c-.1 1.3 1.8 3.4 4.8 5.7a217 217 0 0 0 24.5 15.5z"
          className="prefix__cls-11"
          data-name="Path 159"
          transform="translate(-222.6 -171)"
        />
        <path
          id="prefix__Path_160"
          d="M681.8 341a34.1 34.1 0 0 1-25.5 23.7c-2.5-7.2-4.5-12.3-4.5-12.3s25.8-22.2 25.3-17.2c-.1 1.3 1.8 3.4 4.7 5.7z"
          className="prefix__cls-9"
          data-name="Path 160"
          transform="translate(-222.6 -171)"
        />
        <path
          id="prefix__Path_161"
          d="M665.8 311.7a34 34 0 1 1-10-24.1 34 34 0 0 1 10 24.1z"
          className="prefix__cls-11"
          data-name="Path 161"
          transform="translate(-205.1 -152.8)"
        />
        <path
          id="prefix__Path_162"
          d="M820.6 713l-3.9 3.3-2.2 2.1-1.7 1.8a95 95 0 0 1-15.3-5.4c-4-1.7-7.2-3.8-9-5.8-6.2-6.7-26.3-24.2-65.9-29.4a184.3 184.3 0 0 0-28.8-1.5l-4 .1-.6-3.6.3-.1 7.4-3.2 6.7-2.8a53.6 53.6 0 0 1 14.3-1.8h1.9a12 12 0 0 1 1.4 0h.9a74.5 74.5 0 0 1 4.6.4h.3l.9.1 1.1.2 1.1.2c.8 0 1.6.2 2.3.3l3.5.7 1.7.4 5.2 1.2 1.6.5 1.1.3 1.4.4c3.2 1 6.4 2 9.6 3.2l1.7.6 1.6.6 3 1.2c5.5 2.2 10.8 4.7 16 7.2l1.7.9.9.5 1.8.9 1.7 1 .9.4.9.5.8.4 5.8 3.3 1.6 1 .8.5 3 1.8a70.2 70.2 0 0 1 3.6 2.3l1.4.9.6.4 1.3.9.7.5 1.5 1.1.6.5.3.1 1.6 1.3 1 .7 1 .8 1.9 1.5.8.7.4.3.4.3.7.7.5.4.5.5a22.1 22.1 0 0 1 1.6 1.8l1.2 1.5z"
          className="prefix__cls-9"
          data-name="Path 162"
          transform="translate(-234.6 -277.8)"
        />
        <path
          id="prefix__Path_163"
          d="M805 578s3.4 21.8 6.4 33.7q-1.3.8-2.5 1.8l-4 3.2-2.1 2.1a99 99 0 0 1-11.5-3.4c-6.2-2.3-12-5.2-14.6-8.1-6-6.6-25.4-23.5-63.6-29.1a183 183 0 0 0-29.7-1.8l-5.3.1-.3-1.6-2.3-13.7-2.2-12.8-.2-1.5-.1-.7-.4-2.4-1.2-6.6-.5-3v-2a3 3 0 0 0 0-.5 1.2 1.2 0 0 1 0-.3l-.1-.5a1 1 0 0 1 0-.1v-.7l-.2-1.4a76.4 76.4 0 0 1-.6-5l-.5-3.8-.1-1a3.5 3.5 0 0 0-.1-.6 2.9 2.9 0 0 0 0-.5l-.4-1.9a2.6 2.6 0 0 0 0-.4l-.3-1-.2-1a.1.1 0 0 0 0-.1 2.6 2.6 0 0 0 0-.5l-.2-.7-.3-1.2-.1-.5-.2-.7a11.7 11.7 0 0 0-1.4-3.4 1.5 1.5 0 0 0-.2-.2 1 1 0 0 0-.1-.2 4 4 0 0 1-.6-.7 4.8 4.8 0 0 1-.2-.4 23 23 0 0 1-.5-1l-.1-.1-.2-.4c-3.3-7.4-7.5-26.2-7.5-26.2l-2.7-13-.3-1.5-.8-4.3v-.6l-.4-15.4s-.3-25 7.8-28.6l-.2-3s-6.3-2-7-4.8a2 2 0 0 1 0-1.3 3.7 3.7 0 0 1 1-1.3l.4-.4a17.7 17.7 0 0 0 4.9-9.2l2.6-4.2c5-8 15.8-24.5 20.7-26.3a39 39 0 0 0 11.2-6.7l1.1.3c3.2.7 12.8 2.7 16.5 2.8a16.4 16.4 0 0 1 5.2 2 46.3 46.3 0 0 1 21 21.8c3.2 6.8 6.9 14 8.9 15.6a16 16 0 0 1 3.3 4 51.5 51.5 0 0 1 4.5 8.6s15.5 10.5 13.6 20.7c0 0 3.3 11.5 6.7 14.8s11 30 11 30 2.8 5 2.5 8.9 2.9 11.9 2.9 11.9a127 127 0 0 0 2 8.4 15 15 0 0 0 2.3 5.4c1.9 1.6 1 5.2 1 5.2s2.3 6.2 3.5 7.9a4 4 0 0 1 .6 1.6 25.5 25.5 0 0 1-.1 5.8l-.2 2c-.2 2.9-.4 8 1 9.9a5 5 0 0 1 .6 1.8c.8 3.8.1 11 2 12.7 2.1 1.9 1.1 19.3 1.1 19.3z"
          className="prefix__cls-12"
          data-name="Path 163"
          transform="translate(-222.8 -178.2)"
        />
        <path
          id="prefix__Path_164"
          d="M684 616.4l-3.2 8a656 656 0 0 0-13 32.7c-4 12.2-20.4 19.3-20.4 19.3s-32.7 11.2-44.1 2.9 21.4-26.7 27.4-27.9 11.2-6 15.5-8.6c2-1.2 2.2-6 1.9-10.6a89.7 89.7 0 0 0-1.4-10.4z"
          className="prefix__cls-11"
          data-name="Path 164"
          transform="translate(-206.2 -261.6)"
        />
        <path
          id="prefix__Path_165"
          d="M789.1 450.6s12.4-5.5 17.6 3-17.6-3-17.6-3z"
          className="prefix__cls-9"
          data-name="Path 165"
          transform="translate(-266.6 -207.8)"
        />
        <path
          id="prefix__Path_166"
          d="M822.7 614s-85.5.6-69.3 11.6 18.6 16.2 37.4 11 32-22.7 32-22.7z"
          className="prefix__cls-9"
          data-name="Path 166"
          transform="translate(-254.5 -260.8)"
        />
        <path
          id="prefix__Path_167"
          d="M666.3 311.7a34 34 0 0 1-4.5 17 10.6 10.6 0 0 1-3.5-2.2 16 16 0 0 1-2.5-4.5 39.3 39.3 0 0 0-5.7-9c-1.6-2-3.7-3.8-6-3.5-4 .3-6.9 6.4-10.7 5.1-1.1-.3-2.8-7.7-3.5-9-1.5-3.2-2.4-2.3-5.2-1-5.3 2.6-11.1 4.8-17 3.6a9 9 0 0 1-5.4-2.8 18.7 18.7 0 0 0-1.8-2.2 3.6 3.6 0 0 0-1-.6 34 34 0 0 1 66.8 9.1z"
          className="prefix__cls-9"
          data-name="Path 167"
          transform="translate(-205.7 -152.8)"
        />
        <path
          id="prefix__Path_168"
          fill="#63345e"
          d="M624.5 308.4c3.8 1.2 6.7-4.8 10.6-5.2 2.4-.3 4.5 1.6 6 3.5a39 39 0 0 1 5.8 9 16 16 0 0 0 2.5 4.5 11.5 11.5 0 0 0 3.7 2.4l5.2 2.3c3 1.4 6.8 2.5 9.1 0 1.8-2 1.6-5.4.7-8.1s-2.1-5.5-2-8.3c0-3.2 1.7-6 2.3-9 .9-5.1-1.5-10.3-4.7-14.2s-7.2-6.7-10.5-10.4c-1.9-2.2-3.5-4.5-5.4-6.6a27.3 27.3 0 0 0-8.5-6.3 16 16 0 0 0-7-1.7c-3 0-5.8 1.2-8.7 2.3a41.1 41.1 0 0 1-13.1 3.2c-5.5.1-11.4-1.4-16.1 1.6-3.4 2-5.5 6-7.3 9.8l-4.1 8a42 42 0 0 1-5.3 8.7 11.6 11.6 0 0 1-8.2 4.4 11.5 11.5 0 0 0 12.2 1.2c1.6-.9 3-2.1 4.7-2.8s3.7-1 5.2.3a17 17 0 0 1 1.8 2.2 9 9 0 0 0 5.3 2.8c5.9 1.1 11.7-1 17-3.6 2.9-1.4 3.7-2.3 5.3 1 .7 1.2 2.4 8.6 3.5 9z"
          data-name="Path 168"
          transform="translate(-196.1 -147.3)"
        />
        <path
          id="prefix__Path_169"
          d="M705.8 616.4l-3.4 8-4.9 2.4-8.2 4.3-19.5 1.1a89.7 89.7 0 0 0-1.4-10.4z"
          className="prefix__cls-9"
          data-name="Path 169"
          transform="translate(-227.9 -261.6)"
        />
        <path
          id="prefix__Path_170"
          d="M736.4 441.8l-4.8 16.7s-4.7 10-2.3 19.5-1.5 24-1.5 24l-7.4 19.2s-9.3 19.5-11 19.5c-.8 0-6.8 3-12 5.7l-8.2 4.3-21.9 1.2c-7.2-19-2.2-22.4 1.4-22.7a7.7 7.7 0 0 1 2.7.3l4.7-30v-18.6s1.5-17.9 4.6-23.6a54 54 0 0 0 4.5-11.9s-2.9-5.5-3.6-9a65 65 0 0 1-1-7.7s-3.3.5-4.2-26.7 19.3-34.5 19.3-34.5c24.3-7.4 38.3 13 48 27.9s-7.3 46.4-7.3 46.4z"
          className="prefix__cls-9"
          data-name="Path 170"
          transform="translate(-226.3 -181.2)"
        />
        <path
          id="prefix__Path_171"
          d="M737 439.7l-4.7 16.7s-4.8 10-2.4 19.5-1.4 24-1.4 24L721 519s-9.3 19.6-11 19.6c-.9 0-6.8 3-12 5.7l-8.2 4.3-9.8.5-2.2-12.7s-1.2-16.5-3.5-24.3l2.4-14.7v-18.6s1.4-17.9 4.5-23.6a53.8 53.8 0 0 0 4.5-12s-2.9-5.4-3.6-9a63.2 63.2 0 0 1-1-7.6s-3.3.5-4.2-26.7 19.3-34.5 19.3-34.5c24.3-7.4 38.4 13 48.1 27.8s-7.4 46.5-7.4 46.5z"
          className="prefix__cls-9"
          data-name="Path 171"
          transform="translate(-229.8 -180.5)"
        />
        <path
          id="prefix__Path_172"
          d="M734.3 439.7l-4.8 16.7s-4.7 10-2.3 19.5-1.5 24-1.5 24l-7.3 19.1s-9.3 19.6-11 19.6c-1 0-6.9 3-12 5.7l-8.3 4.3-21.9 1.2c-7.2-19-2.2-22.4 1.3-22.7a7.7 7.7 0 0 1 2.7.3l4.8-30v-18.6s1.4-17.9 4.5-23.6a54 54 0 0 0 4.5-12s-2.8-5.4-3.5-9a64.8 64.8 0 0 1-1-7.6s-3.3.5-4.3-26.7 19.3-34.5 19.3-34.5c24.3-7.4 38.4 13 48.2 27.8s-7.4 46.5-7.4 46.5z"
          className="prefix__cls-12"
          data-name="Path 172"
          transform="translate(-225.7 -180.5)"
        />
        <path
          id="prefix__Path_173"
          d="M696.4 620.5l-8.2 4.3-22 1.2c-7.2-19-2.2-22.3 1.4-22.7 5.2 3.8 12 9 12.5 10.8s9.3 4.5 16.3 6.4z"
          className="prefix__cls-9"
          data-name="Path 173"
          transform="translate(-226 -257.5)"
        />
        <path
          id="prefix__Path_174"
          d="M695.3 621.5l-8.2 4.4-22 1.2c-7.1-19-2.1-22.4 1.4-22.7 5.3 3.8 12 9 12.5 10.7s9.3 4.5 16.3 6.4z"
          className="prefix__cls-12"
          data-name="Path 174"
          transform="translate(-225.7 -257.8)"
        />
        <g
          id="prefix__Group_14"
          className="prefix__cls-14"
          data-name="Group 14"
          transform="translate(373.4 144.2)"
        >
          <path
            id="prefix__Path_175"
            d="M668.6 335.1c-2.3 2.6-6 1.4-9 0l-5.2-2.3a11.3 11.3 0 0 1-3.8-2.3 16 16 0 0 1-2.5-4.5 39.4 39.4 0 0 0-5.7-9c-1.6-2-3.7-3.8-6-3.6-4 .4-6.8 6.5-10.6 5.2-1.2-.4-2.9-7.7-3.5-9-1.6-3.3-2.4-2.3-5.3-1-5.3 2.5-11.1 4.7-17 3.6a9 9 0 0 1-5.3-2.8 17.7 17.7 0 0 0-1.9-2.2c-1.4-1.2-3.4-1-5-.3s-3.2 2-4.8 2.8a11.4 11.4 0 0 1-7.4 1 10.3 10.3 0 0 1-6 2.3 11.5 11.5 0 0 0 12.2 1.2c1.6-.9 3-2 4.7-2.8s3.7-1 5.2.3a17 17 0 0 1 1.8 2.2 9 9 0 0 0 5.3 2.8c5.9 1.1 11.7-1 17-3.6 2.9-1.3 3.7-2.2 5.3 1 .7 1.3 2.3 8.6 3.5 9 3.8 1.3 6.6-4.8 10.6-5.2 2.3-.2 4.4 1.7 6 3.6a39 39 0 0 1 5.7 9 16 16 0 0 0 2.5 4.5 11.5 11.5 0 0 0 3.8 2.4l5.1 2.3c3 1.3 6.8 2.5 9.1 0a6.5 6.5 0 0 0 1.4-4.8 2.2 2.2 0 0 1-.2.2z"
            data-name="Path 175"
            transform="translate(-569.5 -306.3)"
          />
          <path
            id="prefix__Path_176"
            d="M714.8 316.7a19.9 19.9 0 0 0-1.2 4.6 24 24 0 0 0 1-3.7l.2-.9z"
            data-name="Path 176"
            transform="translate(-615.8 -309.6)"
          />
        </g>
        <path
          id="prefix__Path_177"
          d="M512.1 750.5s-4.2 11.4-12.6 11.6z"
          className="prefix__cls-9"
          data-name="Path 177"
          transform="translate(-173.6 -304.7)"
        />
        <path
          id="prefix__Path_178"
          fill="url(#prefix__linear-gradient-2)"
          d="M389.9 560a73.2 73.2 0 0 0-5.5-9.6l-.9-1.3h.6a3 3 0 0 0 2.1-.6c5.3-4.5-5.5-30-11.4-30.3-4-.3-12-.6-17.2-.8H356l-.2-1s-6.7-1.6-10-5.2l-7.4-8a15.7 15.7 0 0 1-5-3.1 3 3 0 0 1-.8-1.8c0-2.4-8-9.3-10-11l-.5-.3s-.7-3.6-3.3-4.3c-1.1-.3-2.4-2-3.6-4a54.4 54.4 0 0 1-2.9-5.6s-3.3-3.9-6-7.7a32.6 32.6 0 0 1-1.8-3 8.1 8.1 0 0 1-1.3-3c-.2-3.4-4-3.6-4-3.6s-3.4-6.7-3.4-8.4-5-5-5-5l-7.9-9s2.2-6.2-5.5-11-8.6-18.5-8.6-18.5l-6.7-14.5-.7-1.5a4.1 4.1 0 0 0 1.5-1.5 4.4 4.4 0 0 0 .4-3.6 16.1 16.1 0 0 0-2.4-5l-.2-.3-.7-1a3 3 0 0 0 .7-.6l.2-.2a3.7 3.7 0 0 0 0-3.8 7.3 7.3 0 0 0-.5-.8c-2.4-3.9-2.8-13-2.8-13l-5.8-16s-.7-9.8-6-16a14 14 0 0 0-5-3.7 11.2 11.2 0 0 0-4.6-3.6l-.3-1.8-.2-1.5a37.3 37.3 0 0 0 5.1.4 36.7 36.7 0 0 0 5-.4 37.6 37.6 0 0 0 15-5.4 38.2 38.2 0 0 0 17-23.3 38.6 38.6 0 0 0 1-9 37.7 37.7 0 0 0-.7-7.8 2.5 2.5 0 0 0-.1-.5l-.8-2.8-.1-.6a18.7 18.7 0 0 0 5.4.6 3.2 3.2 0 0 0 1.8-.5 3.8 3.8 0 0 0 1-1.6l1-2.4a1.9 1.9 0 0 0 0-.2 16.1 16.1 0 0 0 .5-2.3 10.9 10.9 0 0 0 .2-2 7.5 7.5 0 0 0 0-1 7.2 7.2 0 0 0-.3-1.4 1 1 0 0 1 0 .3 6.7 6.7 0 0 0-.4-1c-2-3.9-7.5-5.5-8.6-9.7-.6-2-.1-4.7-1.7-6a7 7 0 0 0-2.5-1c-3.6-1.2-6.3-4-9.4-6a19 19 0 0 0-3.3-1.8c-2.3-1-4.9-1.4-7.2-.3l-1.8 1a10.9 10.9 0 0 1-6 .8l-4-.6c-3.3-.5-7.2-.5-9.4 2-.9 1-1.4 2.2-2.4 3-1.8 1.4-4.4.7-6.7.3s-5.2-.3-6.1 1.9a18.7 18.7 0 0 0-.5 2 6 6 0 0 1-4 3.7 42.2 42.2 0 0 1-5.7 1 21 21 0 0 0-8.4 3.6 8.2 8.2 0 0 0-2.7 3 .7.7 0 0 0-.1-.2 3.5 3.5 0 0 0-.3 1.6 3 3 0 0 0 0 1 4.3 4.3 0 0 0 .3.6 9.2 9.2 0 0 1 .5 1.5 3.1 3.1 0 0 1 0 .6 4.4 4.4 0 0 1-.6 2.3 6.9 6.9 0 0 1-.4.7 26.6 26.6 0 0 1-1.8 2.2 8.8 8.8 0 0 0-1.5 2.2l-.1-.2a4.5 4.5 0 0 0-.3 2 3 3 0 0 0 .2 1.3 2.6 2.6 0 0 0 .4.7 11.3 11.3 0 0 0 2.2 1.5c2 1.4 2.4 4.2 2.5 6.6a56.3 56.3 0 0 1-.5 10.9c-.3 1.5-.8 4.1-1 6.7v1.2c0 2 .3 4 1.4 5.2a3.2 3.2 0 0 0 1 .8 3.4 3.4 0 0 0 2.7-.4l-1.3 3.1-.2.6-1.7 3.5a18.7 18.7 0 0 0-10 1s-1.4 11.1-6.2 12.3-22.2 15.8-22.2 15.8L133.8 362l-.6.7-1.7 2.4A209 209 0 0 0 115 392a82.6 82.6 0 0 0-3.5 12.3c-2.8 12-5 27-4.8 29.5.2 2.9-1 29.7-.6 40.3a22.8 22.8 0 0 0 .4 3.6 31.1 31.1 0 0 1 .3 5.2c0 3.4 0 8.1-.2 13.2-.4 13.7-1.3 29.8-1.3 29.8s4 11.8 6.2 15.3c.4.7.7 1 1 1 1.4-.2 5.4 9.9 5.4 9.9l4.4-.3h.8l.7 1.4.7 1.4c.3.4.4 1 .6 1.3 2.8 5.6 6 11 8 11.5 4.2 1.2 16 7.2 16.9 9.8s17 5.4 24 5.4h3.4v1.2a6.9 6.9 0 0 0 6.8 6.3l5.2.1h.2l-.1 1.2v.3l-.2 1.1-1.5 10.9h.5l14.4.2h1.5v-.4l2-.6.9-.3c12.9-3.7 25.8-7.2 38.8-8.2a86.9 86.9 0 0 1 13 0h2c14 1.5 27.6 6.4 41.2 10.5h6.7l13.8.2h1.3l.3-11.2v-1.5l4.6.1a6.9 6.9 0 0 0 5.3-2.4 6.8 6.8 0 0 0 1.5-3 6.9 6.9 0 0 0 .1-1.5v-1a7 7 0 0 1-.4 8.9 14 14 0 0 1-2.9 2.5 23 23 0 0 0-7 6.3c-1 1.5-.4 2-.4 2h39.7c9.7-4 19-9.4 28.7-13.5a.4.4 0 0 0 0-.1l.8-.3c2.2-5 3.5-21-4.3-30.6zm-161-120.7l.3-1 .8-2 .2.4 14.3 21 1.3 1.4a85.1 85.1 0 0 1-8.4.8 63 63 0 0 1-9.1-1.7l-3.5-1.6a19.6 19.6 0 0 0-.7-4.4l-.1-.5 4.1-10.5zm64.6 66c5.9 4.1 13.2 8.8 20.5 13.4h-3.3l-17.7.5c-6.6-1.5-16.3-3.7-18.8-4.6A2675.9 2675.9 0 0 0 246 507l-10.4-2.7a1.9 1.9 0 0 0-.4-.8 19.8 19.8 0 0 1-2.8-5.1 32.1 32.1 0 0 1-1.5-5s-6.1-.6-7.1-2.7c-.4-.5-.2-1.2.6-2a6 6 0 0 0 1.5-2.1 7.3 7.3 0 0 0 .4-1.1 9.3 9.3 0 0 0 0-3.6 12 12 0 0 0-.7-2.2 41.7 41.7 0 0 1 7.7 2.5c2.9 1.4 8 1.7 12.6 1.7 3.2 0 6.2-.2 8-.3h.4l1.7-.2a109.4 109.4 0 0 0 14.2 1.5l1.5 1.5.5.4c4.5 4.5 9.3 8.8 13.7 12.6 2.7 2.1 5.2 4.1 7.6 5.8z"
          data-name="Path 178"
          transform="translate(-47 -137.3)"
        />
        <path
          id="prefix__Path_179"
          d="M350.2 564.7l61.5-1.4 21.4 11.9 3.4 27.9-56.5-16.2z"
          className="prefix__cls-16"
          data-name="Path 179"
          transform="translate(-112.5 -180.9)"
        />
        <path
          id="prefix__Path_180"
          d="M350.2 564.7l61.5-1.4 21.4 11.9 3.4 27.9-56.5-16.2z"
          className="prefix__cls-6"
          data-name="Path 180"
          transform="translate(-112.5 -180.9)"
        />
        <path
          id="prefix__Path_181"
          d="M316 589.1c.8 0 6.5 7.2 6.5 7.2s21.7 3.8 27-1-10.3-20.7-10.3-20.7l-13.9.7-11.2 6.7z"
          className="prefix__cls-17"
          data-name="Path 181"
          transform="translate(-114 -248.2)"
        />
        <path
          id="prefix__Path_182"
          d="M270.3 562.7l10.5 4.7s6.7 1.7 9 1.7 12.4-1.2 12.4-1.2l9 3.6s-8 15.2-2.8 21c0 0-16.4 1.6-22.6-1.3s-14.5-3.8-14.5-3.8z"
          className="prefix__cls-18"
          data-name="Path 182"
          transform="translate(-100 -244.4)"
        />
        <path
          id="prefix__Path_183"
          d="M272.4 563l10.5 4.8s6.7 1.6 9 1.6 12.4-1.2 12.4-1.2l9 3.6s-8 15.3-2.8 21c0 0-16.4 1.7-22.6-1.2s-14.5-3.8-14.5-3.8z"
          className="prefix__cls-6"
          data-name="Path 183"
          transform="translate(-100.7 -244.5)"
        />
        <path
          id="prefix__Path_184"
          d="M278.2 367s-69-15.8-56.7-17.9c8-1.4 15.2-19.2 19.3-32 2.4-7.2 3.8-12.8 3.8-12.8s39.8 18.6 30.8 24.8c-3.5 2.4-3.9 8.5-3 15.2a119 119 0 0 0 5.8 22.7z"
          className="prefix__cls-17"
          data-name="Path 184"
          transform="translate(-83.9 -161.4)"
        />
        <path
          id="prefix__Path_185"
          d="M355.6 759.6v1.2l-.1 3-.1 1.5-.4 10.2v1h-5v-.8l-1-.2c-13.5-4.2-27.1-9.1-41.1-10.5l-2-.1a86.9 86.9 0 0 0-13 0c-13 1-26 4.6-38.9 8.3l-.8.2-2 .6.1-10.4v-3.3h4.5l37-.3h15z"
          className="prefix__cls-7"
          data-name="Path 185"
          transform="translate(-93.9 -307.6)"
        />
        <path
          id="prefix__Path_186"
          d="M248.7 755.7l-.5 3.3-.3 2-.2 1.4-1.3 9.5-.8.2-2.1.6v.5H242l-3 .8h-11.5l.1-1 1.5-10.9.2-1.4.3-2.8 18.4-2z"
          className="prefix__cls-9"
          data-name="Path 186"
          transform="translate(-86.3 -306.4)"
        />
        <path
          id="prefix__Path_187"
          d="M247.6 755.7l-.4 3.3-.3 2-.2 1.4-1.5 9.8-2 .6v.5h-1.6l-3 .8-.6.2-11.6-.2 1.6-12 .2-1.4.1-1.2.2-1.7z"
          className="prefix__cls-7"
          data-name="Path 187"
          transform="translate(-86 -306.4)"
        />
        <path
          id="prefix__Path_188"
          d="M396.8 668.1v4.1l-.3 10v.2l-14.5.6-2.6.1H377v-1l-.4-10.2v-1.5l-.2-3.2h.7l4.8.2h.7z"
          className="prefix__cls-9"
          data-name="Path 188"
          transform="translate(-121 -214.3)"
        />
        <path
          id="prefix__Path_189"
          d="M397.8 668.1v4.1l-.3 10v1.2l-15.2-.2h-4.2V682l-.4-10.2v-1.4l-.1-3.3 5.4.2z"
          className="prefix__cls-7"
          data-name="Path 189"
          transform="translate(-121.3 -214.3)"
        />
        <path
          id="prefix__Path_190"
          d="M247.6 755.7l-.4 3.3-.3 2-.2 1.4-1.5 9.8-2 .6v.5h-1.6l-3 .8-.6.2-11.6-.2 1.6-12 .2-1.4.1-1.2.2-1.7z"
          className="prefix__cls-10"
          data-name="Path 190"
          transform="translate(-86 -306.4)"
        />
        <path
          id="prefix__Path_191"
          d="M397.8 668.1v4.1l-.3 10v1.2l-15.2-.2h-4.2V682l-.4-10.2v-1.4l-.1-3.3 5.4.2z"
          className="prefix__cls-10"
          data-name="Path 191"
          transform="translate(-121.3 -214.3)"
        />
        <path
          id="prefix__Path_192"
          d="M285.2 329c-3.5 2.5-3.9 8.6-3 15.2a38 38 0 0 1-31.5-27.1c2.4-7.2 3.8-12.8 3.8-12.8s39.8 18.6 30.7 24.8z"
          className="prefix__cls-9"
          data-name="Path 192"
          transform="translate(-93.7 -161.4)"
        />
        <path
          id="prefix__Path_193"
          d="M324.3 287.8a37.8 37.8 0 1 1-1.6-11 37.8 37.8 0 0 1 1.6 11z"
          className="prefix__cls-17"
          data-name="Path 193"
          transform="translate(-93 -144)"
        />
        <path
          id="prefix__Path_194"
          d="M322.7 276.9c-3-.8-6-1.8-9.1-1.8a3 3 0 0 0-2 .5c-1 .7-.8 2-1 3.2a6.7 6.7 0 0 1-3.3 5.3c-2.4 1.3-5.6 1-7.7 2.9-2.7 2.3-2.3 6.5-1.3 9.9a12.9 12.9 0 0 1 .6 4.1 6 6 0 0 1-10.6 3.3c-2-2.4-1.7-5.8-2.2-8.9a16.8 16.8 0 0 0-4.7-9 9 9 0 0 0-4-2.6 4.8 4.8 0 0 0-4.6 1.2c-1.5 1.6-1.3 4.1-1.5 6.4a14.3 14.3 0 0 1-5.9 10.3c-3.2 2.3-7.1 3.1-10.8 4.4a6.6 6.6 0 0 0-1 .6 37.9 37.9 0 1 1 69.1-29.8z"
          className="prefix__cls-9"
          data-name="Path 194"
          transform="translate(-93 -144)"
        />
        <path
          id="prefix__Path_195"
          fill="#ae757a"
          d="M248.6 300.5c3.7-1.3 7.6-2.1 10.8-4.4a14.4 14.4 0 0 0 6-10.3c.1-2.3-.1-4.8 1.4-6.4a4.8 4.8 0 0 1 4.5-1.2 9 9 0 0 1 4.1 2.5 16.8 16.8 0 0 1 4.8 9.1c.5 3 .2 6.5 2.1 9a6 6 0 0 0 10.7-3.4 13 13 0 0 0-.7-4.1c-1-3.4-1.4-7.6 1.3-10 2.1-1.7 5.3-1.5 7.7-2.8a6.7 6.7 0 0 0 3.4-5.3c.1-1.1 0-2.5.9-3.2a3 3 0 0 1 2-.5c5.1 0 10 2.8 15 2.5a3.2 3.2 0 0 0 1.9-.5 3.7 3.7 0 0 0 1-1.5c1.4-3.2 2.4-6.9 1-10-2-3.9-7.5-5.4-8.6-9.7-.6-2 0-4.6-1.7-6a6.9 6.9 0 0 0-2.5-1c-3.5-1.1-6.3-3.8-9.3-5.9s-7.1-3.6-10.5-2l-1.8 1c-3 1.4-6.6.7-10 .1s-7.1-.4-9.4 2c-.8 1-1.3 2.3-2.3 3-1.8 1.4-4.4.7-6.7.3s-5.2-.3-6.1 1.9a16.8 16.8 0 0 0-.5 2 6 6 0 0 1-4 3.7 41.3 41.3 0 0 1-5.7 1 21 21 0 0 0-8.4 3.6c-1.7 1.2-3.5 3.2-3 5.3.2.7.6 1.4.7 2.1.5 2.2-1.3 4-2.8 5.8s-2.7 4.2-1.2 5.9a11.2 11.2 0 0 0 2.1 1.5c2 1.4 2.4 4.1 2.6 6.6a55.5 55.5 0 0 1-.6 10.8c-.5 3.1-2.7 12 1.4 13.8 2.4 1 8-4.4 10.4-5.3z"
          data-name="Path 195"
          transform="translate(-87.7 -139)"
        />
        <path
          id="prefix__Path_196"
          fill="none"
          d="M291 577s-8.8.5-8 3.9 8-3.9 8-3.9z"
          data-name="Path 196"
          transform="translate(-104 -249)"
        />
        <path
          id="prefix__Path_197"
          d="M400 720.8a.4.4 0 0 1-.2 0c-9.6 4.2-19 9.5-28.6 13.7l-2.6 1a75.7 75.7 0 0 1-18.7 5.3 70 70 0 0 1-20-.5c.3-2.7.8-6.5 2-8a30 30 0 0 1 6.2-5 11.8 11.8 0 0 0 3.7-3.7 6.7 6.7 0 0 0 .3-6.4 11.7 11.7 0 0 0-.7-1.3 10.1 10.1 0 0 0-1.4-1.8H223l-39-.2h-4c-6.9 0-23-2.6-24-5.2s-12.7-8.6-17-9.8c-2-.6-5.5-6.7-8.5-12.7l-1.3-2.8-.6-1.4-2.2-5-.3-.6-.1-.4a4 4 0 0 0-.2-.4l-.2-.3-.3-1 106.5-40.7 8.4 2.2 1.3.3 10.8 2.8 15 3.9c6.4 1.7 11.4 3 12.6 3.5a267 267 0 0 0 18.8 4.6l6.2 1.3 19.4 3.9 2.2.4 2.8.6 1.7.3 6 1.3 4.3.9 13.4 2.8 3.3.7 1.3.3 1.2.3c5 1.1 9 2 11.6 2.8a17.9 17.9 0 0 1 2.6 1c5.7 2.6 10.6 8 14.2 13a73.1 73.1 0 0 1 6.3 10.7c7.4 9 6.6 23.7 4.6 29.6z"
          className="prefix__cls-16"
          data-name="Path 197"
          transform="translate(-53.5 -267.2)"
        />
        <path
          id="prefix__Path_198"
          d="M253.5 675s-4.5 20-18.5 27.2 18.5-27.2 18.5-27.2z"
          className="prefix__cls-9"
          data-name="Path 198"
          transform="translate(-87.5 -280.5)"
        />
        <path
          id="prefix__Path_199"
          d="M302 693.2s-15.3 8.9-13.2 15.3z"
          className="prefix__cls-9"
          data-name="Path 199"
          transform="translate(-105.9 -286.3)"
        />
        <path
          id="prefix__Path_200"
          d="M504.3 730.4s-4.3 18.2-13.5 18.4z"
          className="prefix__cls-9"
          data-name="Path 200"
          transform="translate(-170.8 -298.3)"
        />
        <path
          id="prefix__Path_201"
          d="M343.8 666.4v4.1l-15-.2-5.1-.1-95.7-1.6h-3.4l-15.3-.3.6-4.3 19-2.1-.4 3.3 100.5-.7v1.2z"
          className="prefix__cls-9"
          data-name="Path 201"
          transform="translate(-67.2 -212.6)"
        />
        <path
          id="prefix__Path_202"
          d="M362 760.6l-144.2-2.4a6.9 6.9 0 0 1-6.8-6.7v-3.2h158v5.5a6.9 6.9 0 0 1-7 6.8z"
          className="prefix__cls-8"
          data-name="Path 202"
          transform="translate(-81 -304)"
        />
        <path
          id="prefix__Path_203"
          d="M231.6 643.4s-5.5 4.3-8.1 7.8-17 10-17 10c-18 19-60.4 23.8-75.9 25l-1.4-2.9-4-9 106.6-40.7 8.4 2.1a17.2 17.2 0 0 0 1.6 2.4 1.9 1.9 0 0 1 .4.8c.8 3.2-10.6 4.5-10.6 4.5z"
          className="prefix__cls-9"
          data-name="Path 203"
          transform="translate(-53.4 -267.2)"
        />
        <path
          id="prefix__Path_204"
          d="M235 544.7c.8 3.2-10.6 4.4-10.6 4.4s-5.5 4.3-8.1 7.9-17 10-17 10c-18.3 19.1-61.6 23.9-76.5 25l-5.2.2s-4-10-5.4-9.7-7.2-16.2-7.2-16.2 2.4-43 1.2-48 .5-40.2.2-43.5 4.3-32 8.4-41.5 18-29.3 18-29.3l25.8-25.7s17.4-14.6 22.2-15.8 6.2-12.1 6.2-12.1c11.4-4.8 25 5.2 25 5.2 12-.2 10.7 2 10.7 2l7 1.4.1 1.9 8.6 93.3-10.2 25.8-4.8 12.4a19.5 19.5 0 0 1-.5 12.6c-2.6 6.7 1.9 14.6 1.9 14.6s2.9 6-1 9.5 6.5 4.7 6.5 4.7 1.2 6.2 4.3 10a2 2 0 0 1 .4.9z"
          className="prefix__cls-18"
          data-name="Path 204"
          transform="translate(-47 -175.8)"
        />
        <path
          id="prefix__Path_205"
          d="M221.6 597s-4.8 9.1 3.8 10.5 30.7-1 33.6-1-37.4-9.4-37.4-9.4z"
          className="prefix__cls-9"
          data-name="Path 205"
          transform="translate(-84 -255.4)"
        />
        <path
          id="prefix__Path_206"
          d="M220.8 552.5c1.2 2.1 27 23.8 35.7 27.6z"
          className="prefix__cls-9"
          data-name="Path 206"
          transform="translate(-84.1 -241.1)"
        />
        <path
          id="prefix__Path_207"
          d="M247.8 530s13 23 17.2 26.7.7-13 .7-13z"
          className="prefix__cls-9"
          data-name="Path 207"
          transform="translate(-92.8 -233.9)"
        />
        <path
          id="prefix__Path_208"
          d="M194.5 433.1s32.6 21.2 31.2 36.3-31.2-36.3-31.2-36.3z"
          className="prefix__cls-9"
          data-name="Path 208"
          transform="translate(-75.7 -202.8)"
        />
        <path
          id="prefix__Path_209"
          d="M137.5 533.9s-8.4 66 57.9 64.8c0 0-54.1-20-58-64.8z"
          className="prefix__cls-9"
          data-name="Path 209"
          transform="translate(-57.2 -235.1)"
        />
        <path
          id="prefix__Path_210"
          d="M497.4 687.7c-9.6-.2-36.5-10-36.5-10l.2-.7 4.3-21 5.5.2c5.3.2 13.1.5 17.1.8 6.5.4 18.9 31 9.4 30.7z"
          className="prefix__cls-17"
          data-name="Path 210"
          transform="translate(-161.2 -274.4)"
        />
        <path
          id="prefix__Path_211"
          d="M272 366.4l8.6 93.4-10.2 25.8-19.4-28.2c-4.7-6.6-14.5-39.3-14.5-39.3s-2.9-28.8 16.4-44c8.4-6.6 14.7-8.1 19-7.7z"
          className="prefix__cls-9"
          data-name="Path 211"
          transform="translate(-89.1 -181.3)"
        />
        <path
          id="prefix__Path_212"
          d="M452.3 673.7a24.1 24.1 0 0 1-7.1 8.8s-12.5-7.2-26.6-15.9c10.6 2.2 23.5 4.8 33.7 7.1z"
          className="prefix__cls-9"
          data-name="Path 212"
          transform="translate(-147.6 -277.8)"
        />
        <path
          id="prefix__Path_213"
          d="M462.4 677.7l-1.3-.7 4.4-21 5.4.2c3 13.5-8.5 21.5-8.5 21.5z"
          className="prefix__cls-9"
          data-name="Path 213"
          transform="translate(-161.3 -274.4)"
        />
        <path
          id="prefix__Path_214"
          d="M283.5 368.8s-8-12.1-27.3 3.1-16.5 44.1-16.5 44.1 9.8 32.6 14.5 39.3l33 48s29.5 33.5 48.8 47.1 53.8 33.6 53.8 33.6 12-8.3 8.4-22.4c0 0-6.7-1.7-10-5.2l-7.4-7.9s-5.8-2.4-5.8-5-10.4-11.2-10.4-11.2-.8-3.6-3.4-4.3-6.4-9.5-6.4-9.5-8.8-10.2-9-13.6-4.1-3.5-4.1-3.5-3.4-6.7-3.4-8.4-5-5-5-5l-7.8-8.8s2.1-6.2-5.5-11-8.6-18.3-8.6-18.3l-7.4-16a4.2 4.2 0 0 0 2-5 16.8 16.8 0 0 0-3.4-6.1s2.8-1.7.5-5.5-2.9-12.9-2.9-12.9l-5.7-16s-1.2-15.3-11-19.6z"
          className="prefix__cls-18"
          data-name="Path 214"
          transform="translate(-90.1 -180.7)"
        />
        <path
          id="prefix__Path_215"
          d="M333.8 526.7s24.8-6.4 17.4-1.2-17.4 1.2-17.4 1.2z"
          className="prefix__cls-9"
          data-name="Path 215"
          transform="translate(-120.4 -231.8)"
        />
        <path
          id="prefix__Path_216"
          d="M329 567.3s18.7-3.3 14.5 1-14.6-1-14.6-1z"
          className="prefix__cls-9"
          data-name="Path 216"
          transform="translate(-118.8 -245.5)"
        />
        <path
          id="prefix__Path_217"
          d="M274.2 403.6s25.2 6.7 31.2 20.8z"
          className="prefix__cls-9"
          data-name="Path 217"
          transform="translate(-101.2 -193.3)"
        />
        <g
          id="prefix__Group_15"
          className="prefix__cls-14"
          data-name="Group 15"
          transform="translate(144.3 117.7)"
        >
          <path
            id="prefix__Path_218"
            d="M237.1 293.7c-.1-2.5-.5-5.2-2.5-6.6a14 14 0 0 1-2.2-1.5v-.1a3.3 3.3 0 0 0 .3 3.4 11.2 11.2 0 0 0 2.1 1.5 6.5 6.5 0 0 1 2.3 4.5v-1.2z"
            data-name="Path 218"
            transform="translate(-232 -273)"
          />
          <path
            id="prefix__Path_219"
            d="M237.8 269.2a5.1 5.1 0 0 0 .3.9 3.6 3.6 0 0 0 .2-2.1 4.6 4.6 0 0 0-.2-.9 3.6 3.6 0 0 0-.3 2z"
            data-name="Path 219"
            transform="translate(-233.9 -267.1)"
          />
          <path
            id="prefix__Path_220"
            d="M354.9 273a19.8 19.8 0 0 1-1.6 5.4 3.7 3.7 0 0 1-1 1.6 3.3 3.3 0 0 1-1.8.5c-5.2.3-10-2.5-15.1-2.6a3 3 0 0 0-2 .5c-1 .8-.8 2.1-1 3.3a6.7 6.7 0 0 1-3.3 5.2c-2.4 1.4-5.6 1.1-7.7 3s-2.3 4.9-1.8 7.8a6.2 6.2 0 0 1 2-4.5c2.1-1.8 5.3-1.6 7.7-3a6.7 6.7 0 0 0 3.4-5.2c.1-1.1 0-2.5.9-3.2a3 3 0 0 1 2-.6c5.2 0 10 3 15.1 2.6a3.2 3.2 0 0 0 1.8-.5 3.7 3.7 0 0 0 1-1.6c1.2-2.7 2.2-6 1.4-8.8z"
            data-name="Path 220"
            transform="translate(-260 -269)"
          />
          <path
            id="prefix__Path_221"
            d="M290.3 315.6a6.1 6.1 0 0 1-6.4-2c-2-2.5-1.7-5.9-2.2-9a16.9 16.9 0 0 0-4.7-9 9 9 0 0 0-4.2-2.6 4.8 4.8 0 0 0-4.5 1.2c-1.5 1.7-1.3 4.2-1.5 6.4A14.3 14.3 0 0 1 261 311c-3.2 2.3-7.1 3.1-10.8 4.5-2.4.9-8 6.3-10.4 5.2a4.1 4.1 0 0 1-2.1-3c-.1 2.8.3 5.4 2.4 6.4 2.4 1 8-4.4 10.4-5.3 3.6-1.3 7.6-2.2 10.8-4.4A14.3 14.3 0 0 0 267 304c.2-2.3 0-4.8 1.4-6.5a4.8 4.8 0 0 1 4.6-1.1 9 9 0 0 1 4.1 2.5 16.8 16.8 0 0 1 4.7 9.1c.5 3 .3 6.5 2.2 9a6 6 0 0 0 10.6-3.4 9.2 9.2 0 0 0-.3-2.7 6.1 6.1 0 0 1-4 4.7z"
            data-name="Path 221"
            transform="translate(-233.8 -275.4)"
          />
        </g>
        <path
          id="prefix__Path_222"
          d="M66.3 532.4a6.3 6.3 0 0 0-.8 1.6l-.2.5a1.2 1.2 0 0 0-.3-.1 4 4 0 0 0-1.4-.1v-.6c.1-2-.1-4.6-2-3.5s-.5 3 .7 4.2l.3.2c-1.1.8-1.3 2.5-1.5 4.3s-1.7 3.9-2.7 5l-.3.3a3.7 3.7 0 0 0-3-.8v-.5c-1-3-2.6-8.1-4.8-9.3l.2-.3c1-1.3 2-3 .5-3.5s-1.7 1.5-1.6 3a2.4 2.4 0 0 0 0 .6 2.3 2.3 0 0 0-1.6.8l-.2-.3c-1.3-1.5-3.6-3.8-4.3-2-.7 1.6 1.4 3.8 2.8 5l.1.1c-1 3.9 3.2 7 5.5 8.5l.3.1c-3.1 3.7-5 10.6-5 10.6l8.6 1.5s5.8-5 5-9.6h.1c5.8-1.2 7.1-7.3 6.2-11h.1a6.4 6.4 0 0 0 2.7-2c1.6-2.3-1.8-4.9-3.4-2.7z"
          className="prefix__cls-21"
          data-name="Path 222"
          transform="translate(-27 -233.8)"
        />
        <path
          id="prefix__Path_223"
          d="M66.3 532.4a6.3 6.3 0 0 0-.8 1.6l-.2.5a1.2 1.2 0 0 0-.3-.1 4 4 0 0 0-1.4-.1v-.6c.1-2-.1-4.6-2-3.5s-.5 3 .7 4.2l.3.2c-1.1.8-1.3 2.5-1.5 4.3s-1.7 3.9-2.7 5l-.3.3a3.7 3.7 0 0 0-3-.8v-.5c-1-3-2.6-8.1-4.8-9.3l.2-.3c1-1.3 2-3 .5-3.5s-1.7 1.5-1.6 3a2.4 2.4 0 0 0 0 .6 2.3 2.3 0 0 0-1.6.8l-.2-.3c-1.3-1.5-3.6-3.8-4.3-2-.7 1.6 1.4 3.8 2.8 5l.1.1c-1 3.9 3.2 7 5.5 8.5l.3.1c-3.1 3.7-5 10.6-5 10.6l8.6 1.5s5.8-5 5-9.6h.1c5.8-1.2 7.1-7.3 6.2-11h.1a6.4 6.4 0 0 0 2.7-2c1.6-2.3-1.8-4.9-3.4-2.7z"
          className="prefix__cls-9"
          data-name="Path 223"
          transform="translate(-27 -233.8)"
        />
        <path
          id="prefix__Path_224"
          d="M49.2 535.7l-1 3a15.1 15.1 0 0 1-1.3-1c-1.4-1.3-3.4-3.5-2.8-5.1.7-1.8 3 .5 4.3 2l.8 1z"
          className="prefix__cls-21"
          data-name="Path 224"
          transform="translate(-27.3 -234.5)"
        />
        <path
          id="prefix__Path_225"
          d="M54.3 533.3a14 14 0 0 1-1 1.1 15 15 0 0 1-.2-1.5c0-1.6 0-3.6 1.6-3.1s.5 2.2-.4 3.5z"
          className="prefix__cls-21"
          data-name="Path 225"
          transform="translate(-30.2 -233.8)"
        />
        <path
          id="prefix__Path_226"
          d="M72.8 533.8a12.7 12.7 0 0 1-.1 1.8 12 12 0 0 1-1.3-1.1c-1.1-1.2-2.4-3-.6-4.2s2 1.6 2 3.5z"
          className="prefix__cls-21"
          data-name="Path 226"
          transform="translate(-35.6 -234)"
        />
        <path
          id="prefix__Path_227"
          d="M80.8 536a6.5 6.5 0 0 1-2.7 2 7.6 7.6 0 0 1-1 .3l-1.1-1.7a11.5 11.5 0 0 1 .5-1.7 6.3 6.3 0 0 1 .9-1.5c1.6-2.3 5 .3 3.4 2.5z"
          className="prefix__cls-21"
          data-name="Path 227"
          transform="translate(-37.6 -234.7)"
        />
        <path
          id="prefix__Path_228"
          d="M49.8 535.9l.8 1-1 3a15.1 15.1 0 0 1-1.3-1 5.9 5.9 0 0 1 1.2-2.6c0-.2.2-.3.3-.4z"
          className="prefix__cls-9"
          data-name="Path 228"
          transform="translate(-28.7 -235.8)"
        />
        <path
          id="prefix__Path_229"
          d="M54.3 534.8a14 14 0 0 1-1 1.1 15 15 0 0 1-.2-1.5 2 2 0 0 1 1.2.4z"
          className="prefix__cls-9"
          data-name="Path 229"
          transform="translate(-30.3 -235.3)"
        />
        <path
          id="prefix__Path_230"
          d="M57.7 546.8l-2.5 1.1a15 15 0 0 1-1.4-.7c-2.6-1.7-8-5.8-4.4-10.6s6.6 3.8 7.8 8.1l.5 2.1z"
          className="prefix__cls-21"
          data-name="Path 230"
          transform="translate(-28.7 -235.5)"
        />
        <path
          id="prefix__Path_231"
          d="M72.1 536.3a2 2 0 0 1 1.4-.7 12.7 12.7 0 0 1-.1 1.8 12 12 0 0 1-1.3-1.1z"
          className="prefix__cls-9"
          data-name="Path 231"
          transform="translate(-36.4 -235.7)"
        />
        <path
          id="prefix__Path_232"
          d="M78.1 539a7.6 7.6 0 0 1-.9.4l-1.2-1.7a11.5 11.5 0 0 1 .5-1.6 4.3 4.3 0 0 1 1.6 3z"
          className="prefix__cls-9"
          data-name="Path 232"
          transform="translate(-37.6 -235.8)"
        />
        <path
          id="prefix__Path_233"
          d="M67.4 550.2H67c-8.5 1.3-2.8-3.2-2.8-3.2l1-1c1-1 2.5-3 2.6-4.9.3-2.7.6-5.3 3.9-4.6s3.8 12-4.3 13.7z"
          className="prefix__cls-21"
          data-name="Path 233"
          transform="translate(-33.2 -236)"
        />
        <path
          id="prefix__Rectangle_48"
          d="M0 0h16.2v4.3H0z"
          className="prefix__cls-22"
          data-name="Rectangle 48"
          transform="translate(17.9 335.4)"
        />
        <path
          id="prefix__Rectangle_49"
          d="M0 0h21.2v14.9H0z"
          className="prefix__cls-22"
          data-name="Rectangle 49"
          transform="translate(15.3 321.5)"
        />
        <path
          id="prefix__Rectangle_50"
          d="M0 0h16.2v4.3H0z"
          className="prefix__cls-9"
          data-name="Rectangle 50"
          transform="translate(17.9 335.4)"
        />
        <path
          id="prefix__Rectangle_51"
          d="M0 0h21.2v14.9H0z"
          className="prefix__cls-9"
          data-name="Rectangle 51"
          transform="translate(15.3 321.5)"
        />
        <path
          id="prefix__Rectangle_52"
          d="M0 0h16.2v4.3H0z"
          className="prefix__cls-22"
          data-name="Rectangle 52"
          transform="translate(19 335.4)"
        />
        <path
          id="prefix__Path_234"
          d="M59.8 549.2l.6 2.1-2.6 1.2a15.1 15.1 0 0 1-1.3-.8 6.5 6.5 0 0 1 3.3-2.5z"
          className="prefix__cls-9"
          data-name="Path 234"
          transform="translate(-31.3 -240)"
        />
        <path
          id="prefix__Path_235"
          d="M67.4 554.7l-.4.1c-8.5 1.3-2.8-3.3-2.8-3.3l1-.9a5.6 5.6 0 0 1 2.2 4.1z"
          className="prefix__cls-9"
          data-name="Path 235"
          transform="translate(-33.2 -240.5)"
        />
        <path
          id="prefix__Path_236"
          d="M49.5 562.6s4.8-17 11.4-11.7-2.7 13.3-2.7 13.3z"
          className="prefix__cls-21"
          data-name="Path 236"
          transform="translate(-29.1 -240.3)"
        />
        <circle
          id="prefix__Ellipse_22"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 22"
          transform="translate(22.3 303.2)"
        />
        <circle
          id="prefix__Ellipse_23"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 23"
          transform="translate(22.3 305.6)"
        />
        <circle
          id="prefix__Ellipse_24"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 24"
          transform="translate(37.7 303.6)"
        />
        <circle
          id="prefix__Ellipse_25"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 25"
          transform="translate(25.3 316.4)"
        />
        <circle
          id="prefix__Ellipse_26"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 26"
          transform="translate(36.6 307.8)"
        />
        <circle
          id="prefix__Ellipse_27"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 27"
          transform="translate(31 313.3)"
        />
        <circle
          id="prefix__Ellipse_28"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 28"
          transform="translate(24.1 304.2)"
        />
        <circle
          id="prefix__Ellipse_29"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 29"
          transform="translate(36.2 305.2)"
        />
        <circle
          id="prefix__Ellipse_30"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 30"
          transform="translate(34.4 309.4)"
        />
        <circle
          id="prefix__Ellipse_31"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 31"
          transform="translate(28.8 316)"
        />
        <circle
          id="prefix__Ellipse_32"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 32"
          transform="translate(27.7 313.4)"
        />
        <circle
          id="prefix__Ellipse_33"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 33"
          transform="translate(25 307.5)"
        />
        <path
          id="prefix__Rectangle_53"
          d="M0 0h16.2v1.6H0z"
          className="prefix__cls-9"
          data-name="Rectangle 53"
          transform="translate(19 335.4)"
        />
        <path
          id="prefix__Rectangle_54"
          d="M0 0h21.2v14.9H0z"
          className="prefix__cls-22"
          data-name="Rectangle 54"
          transform="translate(16.3 321.5)"
        />
        <circle
          id="prefix__Ellipse_34"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 34"
          transform="translate(29.5 318.4)"
        />
        <circle
          id="prefix__Ellipse_35"
          cx={0.5}
          cy={0.5}
          r={0.5}
          className="prefix__cls-9"
          data-name="Ellipse 35"
          transform="translate(26.3 319)"
        />
        <path
          id="prefix__Path_237"
          d="M985.8 446.5s5.4-16 19.4-10c0 0-6.5 14.1-18.7 12.5z"
          className="prefix__cls-21"
          data-name="Path 237"
          transform="translate(-329.8 -203.4)"
        />
        <path
          id="prefix__Path_238"
          d="M982.6 423.3s6-16 20-8.9c0 0-8.2 14.7-19.3 11.3z"
          className="prefix__cls-21"
          data-name="Path 238"
          transform="translate(-328.8 -196.2)"
        />
        <path
          id="prefix__Path_239"
          d="M981.7 400.4s7.9-15.6 19.2-13.5c0 0-8.1 16.6-18.8 17z"
          className="prefix__cls-21"
          data-name="Path 239"
          transform="translate(-328.5 -187.9)"
        />
        <path
          id="prefix__Path_240"
          d="M982.1 378.4s8.9-19 18-16c0 0-6.4 14.5-18.1 19z"
          className="prefix__cls-21"
          data-name="Path 240"
          transform="translate(-328.6 -180)"
        />
        <path
          id="prefix__Path_241"
          d="M984.2 354.4s8-15.7 17.3-15c0 0-6.2 15.7-17.7 19.3z"
          className="prefix__cls-21"
          data-name="Path 241"
          transform="translate(-329.2 -172.7)"
        />
        <path
          id="prefix__Path_242"
          d="M986.3 331.5s9.3-15.5 15.4-15c0 0-5.4 15.8-15.2 17.8z"
          className="prefix__cls-21"
          data-name="Path 242"
          transform="translate(-330 -165.3)"
        />
        <path
          id="prefix__Path_243"
          d="M988.4 308.8s7-17.3 13.2-17.9c0 0-3 14.6-12.8 19.3z"
          className="prefix__cls-21"
          data-name="Path 243"
          transform="translate(-330.7 -157.1)"
        />
        <path
          id="prefix__Path_244"
          d="M989.3 282s6.6-13.7 11.8-15c0 0-3.5 16.6-11.2 18.7z"
          className="prefix__cls-21"
          data-name="Path 244"
          transform="translate(-331 -149.4)"
        />
        <path
          id="prefix__Path_245"
          d="M989.3 258.5l3-25.3s6.2 20.4-3 29.9z"
          className="prefix__cls-21"
          data-name="Path 245"
          transform="translate(-331 -138.6)"
        />
        <path
          id="prefix__Path_246"
          d="M982 222.2s-3.7-19.4-5.1-20.7c0 0 11 14 7.5 29.1z"
          className="prefix__cls-21"
          data-name="Path 246"
          transform="translate(-327 -128.4)"
        />
        <path
          id="prefix__Path_247"
          d="M976.4 469q-5 3.4-9.8 7.2l-2 1.5a22 22 0 0 1-5.9-1.9c6.3-8.8 13.6-8.2 17.7-6.9z"
          className="prefix__cls-21"
          data-name="Path 247"
          transform="translate(-321.1 -214)"
        />
        <path
          id="prefix__Path_248"
          d="M975.8 449.1s-10.2-13.3-21.6-3.2c0 0 10.8 11.3 21.8 5.8z"
          className="prefix__cls-21"
          data-name="Path 248"
          transform="translate(-319.7 -205.7)"
        />
        <path
          id="prefix__Path_249"
          d="M973.5 424.7s-10.3-13.6-21.6-2.8c0 0 12 11.7 21.6 5.3z"
          className="prefix__cls-21"
          data-name="Path 249"
          transform="translate(-319 -197.8)"
        />
        <path
          id="prefix__Path_250"
          d="M974.9 399.5s-7-16-18.5-14.4c0 0 7.2 17 17.8 17.9z"
          className="prefix__cls-21"
          data-name="Path 250"
          transform="translate(-320.4 -187.3)"
        />
        <path
          id="prefix__Path_251"
          d="M975.1 377.4s-6.5-19.8-15.9-18c0 0 4.6 15.2 15.6 21.2z"
          className="prefix__cls-21"
          data-name="Path 251"
          transform="translate(-321.3 -179)"
        />
        <path
          id="prefix__Path_252"
          d="M977.7 352.8s-7.4-16-16.7-15.6c0 0 5.6 16 17 20z"
          className="prefix__cls-21"
          data-name="Path 252"
          transform="translate(-321.9 -172)"
        />
        <path
          id="prefix__Path_253"
          d="M982.6 329.6s-5-17.4-11-18.5c0 0 1.1 16.7 10.1 21.1z"
          className="prefix__cls-21"
          data-name="Path 253"
          transform="translate(-325.3 -163.6)"
        />
        <path
          id="prefix__Path_254"
          d="M983.2 308s-5.7-17.8-12-18.8c0 0 2.1 14.8 11.5 20.2z"
          className="prefix__cls-21"
          data-name="Path 254"
          transform="translate(-325.2 -156.6)"
        />
        <path
          id="prefix__Path_255"
          d="M986.7 282.9s-4-14.6-9-16.9c0 0 .6 17 7.8 20.4z"
          className="prefix__cls-21"
          data-name="Path 255"
          transform="translate(-327.2 -149.1)"
        />
        <path
          id="prefix__Path_256"
          d="M983.3 258.7l-10.6-23.2s.3 21.3 12 27.5z"
          className="prefix__cls-21"
          data-name="Path 256"
          transform="translate(-325.6 -139.3)"
        />
        <path
          id="prefix__Path_257"
          d="M972.5 226.5s-14.4-13.6-14.7-15.5c0 0 5.8 16.8 20.6 22z"
          className="prefix__cls-21"
          data-name="Path 257"
          transform="translate(-320.8 -131.4)"
        />
        <path
          id="prefix__Path_258"
          d="M969.5 216.2s-15.7-20.6-20.5-21.3c0 0 15.1 3 21 20.4z"
          className="prefix__cls-21"
          data-name="Path 258"
          transform="translate(-318 -126.2)"
        />
        <path
          id="prefix__Path_259"
          d="M986.4 272h-.7c.7-27.7-2-44.5-7.3-47.4l.3-.6c5.7 3 8.4 19.6 7.7 48z"
          className="prefix__cls-23"
          data-name="Path 259"
          transform="translate(-327.4 -135.6)"
        />
        <path
          id="prefix__Path_260"
          d="M982.5 359.5h-1l.7-7.8c2.4-22.7 4.1-43.6 4.5-59.4l.7-.6a747.9 747.9 0 0 1-4.9 67.8z"
          className="prefix__cls-23"
          data-name="Path 260"
          transform="translate(-328.4 -157.4)"
        />
        <path
          id="prefix__Path_261"
          d="M985.3 434q.7 3.7 1.6 7l-1.4 1-1.5-7.2a184 184 0 0 1-2.4-18.6l-.2-2.6v-.4c-.2-3-.3-6.2-.3-9.3v-6.4l.3-7a4.6 4.6 0 0 1 0-.8l.1-1v-.2l.3.2.2.1.5.4v.5q-.3 4.8-.3 9.5a5 5 0 0 0 0 .7v4.5q0 4.5.3 8.8l.1 1.3a2.1 2.1 0 0 0 0 .5l.2 1.2.1 1.6v.2q.7 6.5 1.8 12.6l.6 3.5z"
          className="prefix__cls-23"
          data-name="Path 261"
          transform="translate(-328.3 -188.4)"
        />
        <path
          id="prefix__Path_262"
          d="M1077 406.5l-1.6 1c-4.4 3-8.9 5.9-13.4 8.7v1.3a1.8 1.8 0 0 1-.2 0l-.1-1.2v-1.5l.4-.8c1.6-2.3 7.1-9.1 14.9-7.5z"
          className="prefix__cls-21"
          data-name="Path 262"
          transform="translate(-354.2 -194.1)"
        />
        <path
          id="prefix__Path_263"
          d="M1063.2 391.5s9-14.4 21.3-4.6c0 0-11 12.6-21.1 7z"
          className="prefix__cls-21"
          data-name="Path 263"
          transform="translate(-354.7 -186.8)"
        />
        <path
          id="prefix__Path_264"
          d="M1066.6 369.2s11-13.6 21.6-9.2c0 0-11.4 14.5-21.9 12.7z"
          className="prefix__cls-21"
          data-name="Path 264"
          transform="translate(-355.7 -179)"
        />
        <path
          id="prefix__Path_265"
          d="M1071.1 347.7s12.6-16.7 20.9-12c0 0-9.3 13-21.6 15z"
          className="prefix__cls-21"
          data-name="Path 265"
          transform="translate(-357 -171.2)"
        />
        <path
          id="prefix__Path_266"
          d="M1078.1 324.8s11.1-13.7 20-11c0 0-9.3 14-21.3 15.1z"
          className="prefix__cls-21"
          data-name="Path 266"
          transform="translate(-359 -164.3)"
        />
        <path
          id="prefix__Path_267"
          d="M1085.1 302.6s12.4-13.2 18.2-11.4c0 0-8.6 14.4-18.6 14.2z"
          className="prefix__cls-21"
          data-name="Path 267"
          transform="translate(-361.6 -157.1)"
        />
        <path
          id="prefix__Path_268"
          d="M1091.8 280.7s10.3-15.5 16.6-14.7c0 0-6 13.6-16.5 16.2z"
          className="prefix__cls-21"
          data-name="Path 268"
          transform="translate(-363.9 -149)"
        />
        <path
          id="prefix__Path_269"
          d="M1098.3 254.5s9.3-12 14.7-12.3c0 0-6.9 15.7-14.8 16z"
          className="prefix__cls-21"
          data-name="Path 269"
          transform="translate(-366 -141.5)"
        />
        <path
          id="prefix__Path_270"
          d="M1101.8 230.7l8.1-24.2s2 21.3-9 28.7z"
          className="prefix__cls-21"
          data-name="Path 270"
          transform="translate(-366.8 -130)"
        />
        <path
          id="prefix__Path_271"
          d="M1105.1 193.4s.4-19.8-.8-21.3c0 0 8 16 1.3 30z"
          className="prefix__cls-21"
          data-name="Path 271"
          transform="translate(-367.9 -119)"
        />
        <path
          id="prefix__Path_272"
          d="M1029.3 438a18.7 18.7 0 0 1 8.6-4.8l-8.3 5z"
          className="prefix__cls-21"
          data-name="Path 272"
          transform="translate(-343.8 -202.8)"
        />
        <path
          id="prefix__Path_273"
          d="M1052 414.9l-.3 1.3-.2 1.3-.6.1a13 13 0 0 1-2 .3c-10.4.8-17.4-10.6-17.4-10.6 10.5-6 17.2 2.4 19.5 6l1 1.6z"
          className="prefix__cls-21"
          data-name="Path 273"
          transform="translate(-344.5 -193.8)"
        />
        <path
          id="prefix__Path_274"
          d="M1054.6 390.5s-7.2-15.3-20.5-7.1c0 0 9.3 13.9 20 9.6z"
          className="prefix__cls-21"
          data-name="Path 274"
          transform="translate(-345.3 -186)"
        />
        <path
          id="prefix__Path_275"
          d="M1061.6 365.5s-3.6-17.1-15.1-18c0 0 3.6 18.1 13.8 21.2z"
          className="prefix__cls-21"
          data-name="Path 275"
          transform="translate(-349.3 -175.3)"
        />
        <path
          id="prefix__Path_276"
          d="M1066.4 343.9s-2.3-20.8-11.8-20.9c0 0 1.3 15.8 11 23.9z"
          className="prefix__cls-21"
          data-name="Path 276"
          transform="translate(-352 -167.4)"
        />
        <path
          id="prefix__Path_277"
          d="M1074 320.3s-4-17-13.2-18.6c0 0 2.3 16.7 12.5 23z"
          className="prefix__cls-21"
          data-name="Path 277"
          transform="translate(-354 -160.6)"
        />
        <path
          id="prefix__Path_278"
          d="M1083.4 298.6s-1.2-18-7-20.4c0 0-2.3 16.6 5.6 22.8z"
          className="prefix__cls-21"
          data-name="Path 278"
          transform="translate(-358.8 -153)"
        />
        <path
          id="prefix__Path_279"
          d="M1088.6 277.5s-2-18.5-7.9-20.7c0 0-1 14.8 7.1 22z"
          className="prefix__cls-21"
          data-name="Path 279"
          transform="translate(-360.3 -146.1)"
        />
        <path
          id="prefix__Path_280"
          d="M1096.9 253.7s-1-15-5.3-18.3c0 0-3 16.8 3.3 21.5z"
          className="prefix__cls-21"
          data-name="Path 280"
          transform="translate(-363.6 -139.3)"
        />
        <path
          id="prefix__Path_281"
          d="M1098.4 229.3l-5.6-24.9s-4 21 6.1 29.5z"
          className="prefix__cls-21"
          data-name="Path 281"
          transform="translate(-364 -129.3)"
        />
        <path
          id="prefix__Path_282"
          d="M1094.9 195.6s-11.3-16.2-11.2-18.1c0 0 2.2 17.6 15.6 25.6z"
          className="prefix__cls-21"
          data-name="Path 282"
          transform="translate(-361.3 -120.7)"
        />
        <path
          id="prefix__Path_283"
          d="M1094 184.9s-11.1-23.4-15.6-25c0 0 14.2 6 16.4 24.2z"
          className="prefix__cls-21"
          data-name="Path 283"
          transform="translate(-359.6 -115)"
        />
        <path
          id="prefix__Path_284"
          d="M1097.8 243l-.7-.1c6.4-27 7.3-44 2.6-48l.4-.5c5 4.2 4.2 21-2.3 48.6z"
          className="prefix__cls-23"
          data-name="Path 284"
          transform="translate(-365.6 -126.1)"
        />
        <path
          id="prefix__Path_285"
          d="M1070.7 328.5l-1-.3 2.3-7.5c7-21.6 13-41.7 16.6-57.1l.8-.5a747.8 747.8 0 0 1-18.7 65.4z"
          className="prefix__cls-23"
          data-name="Path 285"
          transform="translate(-356.8 -148.2)"
        />
        <path
          id="prefix__Path_286"
          d="M1068 356.9l-.1.5q-1.4 4.7-2.4 9.3l-.1.6q-.5 2-.8 4.1a1.5 1.5 0 0 1-.1.3q-1 5-1.6 10a3 3 0 0 1 0 .5l-.4 2.8v.2a163 163 0 0 0-.9 12.7v3.5a1.8 1.8 0 0 1-.3-.1v-1.1l-.4.2-.1 1.2-.7.2v-1l.1-3.3a174.9 174.9 0 0 1 1.7-17q.7-4.7 1.7-9.5l1.3-6.3 1.7-6.7.2-.9.3-1v-.1l.3.2.2.2z"
          className="prefix__cls-23"
          data-name="Path 286"
          transform="translate(-353.7 -178)"
        />
      </g>
      <circle
        id="prefix__Ellipse_36"
        cx={42}
        cy={42}
        r={42}
        className="prefix__cls-24"
        data-name="Ellipse 36"
        transform="translate(1769 2489)"
      />
      <circle
        id="prefix__Ellipse_37"
        cx={19}
        cy={19}
        r={19}
        className="prefix__cls-24"
        data-name="Ellipse 37"
        transform="translate(1792 2428)"
      />
      <circle
        id="prefix__Ellipse_38"
        cx={10}
        cy={10}
        r={10}
        className="prefix__cls-24"
        data-name="Ellipse 38"
        transform="translate(1843 2466)"
      />
    </g>
  </svg>
);
